import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
    CaretDownOutlined,
    CaretUpOutlined,
    CloseCircleOutlined,
    ExclamationCircleOutlined,
    MinusCircleOutlined,
    PlusCircleOutlined,
    QuestionCircleOutlined
} from '@ant-design/icons';

import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import {
    Checkbox,
    InputNumber,
    Radio,
    Select,
    Tooltip,
    Input,
    Button,
    Tabs,
    Dropdown,
    Menu,
    Space,
    notification
} from 'antd';
import {
    MTJ__SINGLE_END_A,
    MTJ__SINGLE_END_B,
    MTJ__SINGLE_END_A_THEN_END_B,
    MTJ__DOUBLE,
    TJ_TYPE__MEASURE,
    TJ_TYPE__AUTO,
    TJ_TYPE__MANUAL,
    TJ_TYPE__USER_INPUT,
    MIN_INTERNAL_SWITCH_CHANNEL,
    MAX_INTERNAL_SWITCH_CHANNEL,
    MIN_EXTERNAL_SWITCH_CHANNEL,
    MAX_EXTERNAL_SWITCH_CHANNEL,
    CORE_SIZE__SINGLEMODE,
    CORE_SIZE__MULTIMODE_50,
    CORE_SIZE__MULTIMODE_62_5,
    ASSEMBLY_LENGTH__LT_100_M,
    ASSEMBLY_LENGTH__LT_500_M,
    ASSEMBLY_LENGTH__LT_1500_M,
    ASSEMBLY_LENGTH__LT_4000_M,
    RL_MODE__FAST,
    RL_MODE__STANDARD,
    TEST_PLAN_TEMPLATE__SIMPLEX
} from '@shared/constants/constants';
import { Api } from '../../../lib/api';
import { Pagination } from '@material-ui/lab';
import SyncPolarityModal from '../components/SyncPolarityModal'
import './ILRLPage.scss';
import ModifyFibersModal from '../components/ModifyFibersModal';
import CreateConnectorModal from '../components/CreateConnectorModal';

const { TabPane } = Tabs;

const TAB__FIBER_SPECIFICATIONS = "TAB__FIBER_SPECIFICATIONS";
const TAB__FIBER_MAPPING = "TAB__FIBER_MAPPING";
const TAB__REFERENCE_MAPPING = "TAB__REFERENCE_MAPPING";
const TAB__ADDITIONAL_SPECIFICATIONS = "TAB__ADDITIONAL_SPECIFICATIONS";

export class ILRLPage extends React.PureComponent {
    static propTypes = {
        assembly: PropTypes.object,
        updateAssembly: PropTypes.func,
        equipment: PropTypes.object,
        updateEquipment: PropTypes.func,
        updateIlComp: PropTypes.func,
        setConnectors: PropTypes.func,
        wizard: PropTypes.object,
        updateWizardData: PropTypes.func
    };

    state = {
        connectors: [],
        lastIndex: 12,
        firstIndex: 0,
        lastIndexFiberMapping: 12,
        firstIndexFiberMapping: 0,
        lastIndexReferenceMapping: 12,
        firstIndexReferenceMapping: 0,
        name: null,
        il: null,
        rl: null,
        visible: false
    };

    updateConnectors = async () => {
        return Api.getConnectors().then((connectors) =>
            this.setState({ connectors: connectors.sort((a, b) => a.name.localeCompare(b.name)) })
        );
    }

    updateConnectorsFromModal = async (connector) => {
        this.updateConnectors().then(() => {
            this.props.assembly.connectorEndA = connector.name;
            this.props.assembly.connectorEndB = connector.name;
            this.selectEndAConnector(connector.id);
            this.selectEndBConnector(connector.id);
        })
    }

    addNewConnectorAsCurrentConnector(connector) {
        this.props.assembly.connectorEndA = connector.name;
        this.props.assembly.connectorEndB = connector.name;
        this.selectEndAConnector(connector.id);
        this.selectEndBConnector(connector.id);
    }

    componentDidMount() {
        this.updateConnectors();
    }

    componentDidUpdate(prevProps) {
        if (
            this.props.wizard.fibersPerCable !== prevProps.wizard.fibersPerCable ||
            this.props.wizard.cablesPerAssembly !== prevProps.wizard.cablesPerAssembly
        ) {
            this.updateConnectors();
        }
    }
    onChange = (event, page) => {
        let indexOfLastTodo = page * 12;
        let indexOfFirstTodo = indexOfLastTodo - 12;

        if (indexOfLastTodo > this.props.wizard.fibersPerCable * this.props.wizard.cablesPerAssembly) {
            let temp = indexOfLastTodo - this.props.wizard.fibersPerCable * this.props.wizard.cablesPerAssembly;

            this.setState({ lastIndex: indexOfLastTodo - temp, firstIndex: indexOfFirstTodo });
        } else {
            this.setState({ lastIndex: indexOfLastTodo, firstIndex: indexOfFirstTodo });
        }
    };
    onChangeFiberMapping = (event, page) => {
        let indexOfLastFiberMapping = page * 12;
        let indexOfFirstFiberMapping = indexOfLastFiberMapping - 12;

        let temp = 0;

        if (
            this.props.equipment.mtjConfiguration === MTJ__SINGLE_END_A ||
            this.props.equipment.mtjConfiguration === MTJ__SINGLE_END_B ||
            this.props.equipment.mtjConfiguration === MTJ__DOUBLE
        ) {
            if (indexOfLastFiberMapping > this.props.wizard.fibersPerCable * this.props.wizard.cablesPerAssembly) {
                temp = indexOfLastFiberMapping - this.props.wizard.fibersPerCable * this.props.wizard.cablesPerAssembly;
                this.setState({
                    lastIndexFiberMapping: indexOfLastFiberMapping - temp,
                    firstIndexFiberMapping: indexOfFirstFiberMapping
                });
            } else {
                this.setState({
                    lastIndexFiberMapping: indexOfLastFiberMapping,
                    firstIndexFiberMapping: indexOfFirstFiberMapping
                });
            }
        } else {
            if (indexOfLastFiberMapping > this.props.wizard.fibersPerCable * this.props.wizard.cablesPerAssembly * 2) {
                temp = indexOfLastFiberMapping - this.props.wizard.fibersPerCable * this.props.wizard.cablesPerAssembly * 2;
                this.setState({
                    lastIndexFiberMapping: indexOfLastFiberMapping - temp,
                    firstIndexFiberMapping: indexOfFirstFiberMapping
                });
            } else {
                this.setState({
                    lastIndexFiberMapping: indexOfLastFiberMapping,
                    firstIndexFiberMapping: indexOfFirstFiberMapping
                });
            }
        }
    };

    onChangeReferenceMapping = (event, page) => {
        let indexOfLastReference = page * 12;
        let indexOfFirstReference = indexOfLastReference - 12;

        if (indexOfLastReference > this.props.equipment.reference.fibers.length) {
            let temp = indexOfLastReference - this.props.equipment.reference.fibers.length;

            this.setState({
                lastIndexReferenceMapping: indexOfLastReference - temp,
                firstIndexReferenceMapping: indexOfFirstReference
            });
        } else {
            this.setState({
                lastIndexReferenceMapping: indexOfLastReference,
                firstIndexReferenceMapping: indexOfFirstReference
            });
        }
    };
    onWavelengthClick(wavelength) {
        if (wavelength === 'wavelength_850') {
            this.props.updateWizardData((prevState) => ({
                [wavelength]: !prevState[wavelength],
                ilComp: { ...prevState.ilComp, attenuation_850: null }
            }));
        }

        if (wavelength === 'wavelength_1300') {
            this.props.updateWizardData((prevState) => ({
                [wavelength]: !prevState[wavelength],
                ilComp: { ...prevState.ilComp, attenuation_1300: null }
            }));
        }

        if (wavelength === 'wavelength_1310') {
            this.props.updateWizardData((prevState) => ({
                [wavelength]: !prevState[wavelength],
                ilComp: { ...prevState.ilComp, attenuation_1310: null }
            }));
        }

        if (wavelength === 'wavelength_1490') {
            this.props.updateWizardData((prevState) => ({
                [wavelength]: !prevState[wavelength],
                ilComp: { ...prevState.ilComp, attenuation_1490: null }
            }));
        }

        if (wavelength === 'wavelength_1550') {
            this.props.updateWizardData((prevState) => ({
                [wavelength]: !prevState[wavelength],
                ilComp: { ...prevState.ilComp, attenuation_1550: null }
            }));
        }

        if (wavelength === 'wavelength_1625') {
            this.props.updateWizardData((prevState) => ({
                [wavelength]: !prevState[wavelength],
                ilComp: { ...prevState.ilComp, attenuation_1625: null }
            }));
        }
    }

    showModal = () => {
        this.setState({
            name: null,
            il: null,
            rl: null,
            visible: true
        });
    };

    handleCancel = (e) => {
        this.setState({
            name: null,
            il: null,
            rl: null,
            visible: false
        });
    };

    closeCreateConnectorModal = () => {
        this.setState({
            visible: false
        })
    }


    selectEndAConnector = (connectorId) => {
        let connector = this.state.connectors.find(
            (connector) => connector.id === connectorId
        );
        if (connector) {
            this.props.updateAssembly({
                ilEndA: connector.mapping[0].il,
                rlEndA: connector.mapping[0].rl,
                connectorEndA: connector.name
            });
        }
    }

    selectEndBConnector = (connectorId) => {
        let connector = this.state.connectors.find(
            (connector) => connector.id === connectorId
        );
        if (connector) {
            this.props.updateAssembly({
                ilEndB: connector.mapping[0].il,
                rlEndB: connector.mapping[0].rl,
                connectorEndB: connector.name
            });
        }
    }

    render() {
        return (
            <div className="page il-rl-page">
                <div className="wizard-card">
                    <div className="section" data-testid="wavelengthSelection">
                        <div className="title">Wavelengths:</div>
                        <Form.Item
                            validateStatus={this.props.wizard.validation.fields.wavelengths ? '' : 'error'}
                            help={this.props.wizard.validation.fields.wavelengths ? '' : 'Must select one or more wavelengths'}
                        >
                            {(this.props.wizard.assembly.coreSize === CORE_SIZE__MULTIMODE_50 ||
                                this.props.wizard.assembly.coreSize === CORE_SIZE__MULTIMODE_62_5) && (
                                <React.Fragment>
                                    <Button
                                        type={this.props.wizard.wavelength_850 ? 'primary' : 'default'}
                                        onClick={() => this.onWavelengthClick('wavelength_850')}
                                    >
                                        850
                                    </Button>
                                    <Button
                                        type={this.props.wizard.wavelength_1300 ? 'primary' : 'default'}
                                        onClick={() => this.onWavelengthClick('wavelength_1300')}
                                    >
                                        1300
                                    </Button>
                                </React.Fragment>
                            )}
                            {this.props.wizard.assembly.coreSize === CORE_SIZE__SINGLEMODE && (
                                <React.Fragment>
                                    <Button
                                        type={this.props.wizard.wavelength_1310 ? 'primary' : 'default'}
                                        onClick={() => this.onWavelengthClick('wavelength_1310')}
                                    >
                                        1310
                                    </Button>
                                    <Button
                                        type={this.props.wizard.wavelength_1490 ? 'primary' : 'default'}
                                        onClick={() => this.onWavelengthClick('wavelength_1490')}
                                    >
                                        1490
                                    </Button>
                                    <Button
                                        type={this.props.wizard.wavelength_1550 ? 'primary' : 'default'}
                                        onClick={() => this.onWavelengthClick('wavelength_1550')}
                                    >
                                        1550
                                    </Button>
                                    <Button
                                        type={this.props.wizard.wavelength_1625 ? 'primary' : 'default'}
                                        onClick={() => this.onWavelengthClick('wavelength_1625')}
                                    >
                                        1625
                                    </Button>
                                </React.Fragment>
                            )}
                        </Form.Item>
                    </div>

                    {this.props.assembly.coreSize === CORE_SIZE__SINGLEMODE && (
                        <div className="section" data-testid="assemblyLengthSelection">
                            <div className="title">Assembly Length:</div>
                            <Radio.Group
                                buttonStyle="solid"
                                value={this.props.wizard.assemblyLength}
                                onChange={(e) => this.props.updateWizardData({ assemblyLength: e.target.value })}
                            >
                                <Radio.Button value={ASSEMBLY_LENGTH__LT_100_M}>&lt; 100m</Radio.Button>
                                <Radio.Button value={ASSEMBLY_LENGTH__LT_1500_M}>&lt; 1500m</Radio.Button>
                                <Radio.Button value={ASSEMBLY_LENGTH__LT_4000_M}>&lt; 4000m</Radio.Button>
                            </Radio.Group>
                        </div>
                    )}

                    {((this.props.assembly.coreSize === CORE_SIZE__MULTIMODE_50) ||
                      (this.props.assembly.coreSize === CORE_SIZE__MULTIMODE_62_5)) && (
                        <div className="section" data-testid="assemblyLengthSelection">
                            <div className="title">Assembly Length:</div>
                            <Radio.Group
                                buttonStyle="solid"
                                value={this.props.wizard.assemblyLength}
                                onChange={(e) => {
                                    if (e.target.value === ASSEMBLY_LENGTH__LT_100_M && this.props.assembly.coreSize !== CORE_SIZE__SINGLEMODE) {
                                        notification.warning({
                                            message: 'Assembly Length < 100m for Multimode is only supported on RLM-110',
                                            placement: 'bottomRight'
                                        });
                                    }

                                    this.props.updateWizardData({ assemblyLength: e.target.value });
                                }}
                            >
                                <Tooltip title={
                                    <>
                                        [RLM-110 Required]
                                    </>
                                }>
                                    <Radio.Button value={ASSEMBLY_LENGTH__LT_100_M}>&lt; 100m</Radio.Button>
                                </Tooltip>
                                <Radio.Button value={ASSEMBLY_LENGTH__LT_500_M}>&lt; 500m</Radio.Button>
                            </Radio.Group>
                        </div>
                    )}

                    {(this.props.assembly.insertionLossTotal ||
                        this.props.assembly.insertionLossSideA ||
                        this.props.assembly.insertionLossSideB) && (
                        <div className="side_by_side_2">
                            <div className="section cust" data-testid="ilCompSelection">
                                <div className="title">IL Compensation:</div>
                                <Tooltip
                                    placement="top"
                                    title="Requires length test. Increase IL specification by (Measured Length x dB/km) to account for IL contribution of the fiber."
                                >
                                    <Button
                                        type={this.props.wizard.ilComp.enable ? 'primary' : 'default'}
                                        onClick={() =>
                                            this.props.updateIlComp({
                                                enable: true
                                            })
                                        }
                                        disabled={!this.props.wizard.showDutLength}
                                        className={this.props.wizard.ilComp.enable ? 'border-select' : ''}
                                    >
                                        Enable
                                    </Button>
                                </Tooltip>

                                <Tooltip
                                    placement="top"
                                    title=" IL specifications will not be adjusted to account for fiber contributions."
                                >
                                    <Button
                                        type={!this.props.wizard.ilComp.enable ? 'primary' : 'default'}
                                        onClick={() =>
                                            this.props.updateIlComp({
                                                enable: false,
                                                userInput: false
                                            })
                                        }
                                        disabled={!this.props.wizard.showDutLength}
                                        className={!this.props.wizard.ilComp.enable ? 'border-select' : ''}
                                    >
                                        Disable
                                    </Button>
                                </Tooltip>
                            </div>
                            <div className="user-input">
                                <div className="sub_title">CABLE ASSEMBLY ONLY</div>
                                <Tooltip
                                    placement="top"
                                    title="Increase IL specification by (Nominal Length x dB/km). User will be prompted to enter length at run-time"
                                >
                                    <Button
                                        type={this.props.wizard.ilComp.userInput ? 'primary' : 'default'}
                                        onClick={() => {
                                            if (this.props.wizard.showDutLength) {
                                                if (this.props.wizard.ilComp.userInput) {
                                                    this.props.updateIlComp({
                                                        userInput: false
                                                    });
                                                } else {
                                                    this.props.updateIlComp({
                                                        enable: true,
                                                        userInput: true
                                                    });
                                                }
                                            } else {
                                                if (this.props.wizard.ilComp.userInput) {
                                                    this.props.updateIlComp({
                                                        enable: false,
                                                        userInput: false
                                                    });
                                                } else {
                                                    this.props.updateIlComp({
                                                        enable: true,
                                                        userInput: true
                                                    });
                                                }
                                            }
                                        }}
                                    >
                                        User Input
                                    </Button>{' '}
                                </Tooltip>
                            </div>
                        </div>
                    )}

                    <div className="section">
                        <div className="title">RL Mode:</div>
                        <div className="tooltip-container">
                            <Radio.Group
                                buttonStyle="solid"
                                value={this.props.wizard.equipment.rlMode}
                                onChange={(e) => {
                                    if (e.target.value === RL_MODE__STANDARD && this.props.assembly.coreSize !== CORE_SIZE__SINGLEMODE) {
                                        notification.warning({
                                            message: 'Standard RL Mode for Multimode is only supported on RLM-110',
                                            placement: 'bottomRight'
                                        });
                                    }

                                    this.props.updateWizardData({
                                        equipment: {
                                            ...this.props.wizard.equipment,
                                            rlMode: e.target.value
                                        }
                                    });
                                }}
                            >
                                <Tooltip title={this.props.assembly.coreSize !== CORE_SIZE__SINGLEMODE ? "Fast (<1.5s) : <50 db" : "Fast (<1.5s) : <75 db"}>
                                    <Radio.Button value={RL_MODE__FAST}>Fast</Radio.Button>
                                </Tooltip>
                                <Tooltip title={
                                    <>
                                        {
                                            this.props.assembly.coreSize !== CORE_SIZE__SINGLEMODE
                                            ? (
                                                <>
                                                    Standard (&lt;5s) : &lt;60 db
                                                    <br />
                                                    [RLM-110 Required]
                                                </>
                                            )
                                            : (
                                                "Standard (<5s) : <85 db"
                                            )
                                        }
                                    </>
                                }>
                                    <Radio.Button value={RL_MODE__STANDARD}>Standard</Radio.Button>
                                </Tooltip>
                            </Radio.Group>
                        </div>
                    </div>

                    {(this.props.wizard.assembly.insertionLossSideA ||
                        this.props.wizard.assembly.insertionLossSideB ||
                        this.props.wizard.assembly.returnLossSideA ||
                        this.props.wizard.assembly.returnLossSideB ||
                        this.props.wizard.assembly.insertionLossTotal ||
                        this.props.wizard.assembly.returnLossTotal) && (
                        <React.Fragment>
                            <div className="section">
                                <div className="title">
                                    Specifications:{' '}
                                    <Tooltip
                                        placement="right"
                                        title="Select a pre-defined Connector or enter the test specifications directly in the table below"
                                    >
                                        <QuestionCircleOutlined style={{ color: '#4d4dff' }} />
                                    </Tooltip>
                                    &nbsp;
                                    {!this.props.wizard.validation.fields.riValid && (
                                        <ExclamationCircleOutlined style={{ color: '#e60013' }} />
                                    )}
                                </div>
                                <div className="cable">
                                    <div>
                                        <table className="specification-table">
                                            <tbody>
                                                <tr>
                                                    <td className="empty-corner" />
                                                    <td>Criteria</td>
                                                    <td>Specification</td>
                                                </tr>
                                                <tr>
                                                    <td rowSpan="3">IL</td>
                                                    <td>
                                                        IL<sub>A</sub>
                                                    </td>
                                                    <td>
                                                        &le;{' '}
                                                        <InputNumber
                                                            data-testid="ilEndASpecInput"
                                                            disabled={
                                                                !this.props.assembly.insertionLossSideA ||
                                                                this.props.equipment.mtjConfiguration === MTJ__DOUBLE
                                                            }
                                                            value={this.props.assembly.ilEndA}
                                                            onChange={(value) => {
                                                                if (value > 0 && value < 10000) {
                                                                    this.props.updateAssembly({ ilEndA: value });
                                                                }
                                                            }}
                                                            formatter={(value) =>
                                                                `${value.toString().replace(/^[A-Za-z--]+$/, '')}`
                                                            }
                                                            min={0}
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        IL<sub>B</sub>
                                                    </td>
                                                    <td>
                                                        &le;{' '}
                                                        <InputNumber
                                                            data-testid="ilEndBSpecInput"
                                                            disabled={
                                                                !this.props.assembly.insertionLossSideB ||
                                                                this.props.equipment.mtjConfiguration === MTJ__DOUBLE
                                                            }
                                                            value={this.props.assembly.ilEndB}
                                                            onChange={(value) => {
                                                                if (value > 0 && value < 10000) {
                                                                    this.props.updateAssembly({ ilEndB: value });
                                                                }
                                                            }}
                                                            formatter={(value) =>
                                                                `${value.toString().replace(/^[A-Za-z--]+$/, '')}`
                                                            }
                                                            min={0}
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        IL<sub>total</sub>
                                                    </td>
                                                    <td>
                                                        &le;
                                                        <InputNumber
                                                            data-testid="ilTotalSpecInput"
                                                            disabled={
                                                                !this.props.assembly.insertionLossTotal ||
                                                                this.props.equipment.mtjConfiguration !== MTJ__DOUBLE
                                                            }
                                                            value={this.props.assembly.ilTotal}
                                                            onChange={(value) => {
                                                                if (value > 0 && value < 10000) {
                                                                    this.props.updateAssembly({ ilTotal: value });
                                                                }
                                                            }}
                                                            formatter={(value) =>
                                                                `${value.toString().replace(/^[A-Za-z--]+$/, '')}`
                                                            }
                                                            min={0}
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td rowSpan="3">RL</td>
                                                    <td>
                                                        RL<sub>A</sub>
                                                    </td>
                                                    <td>
                                                        &ge;{' '}
                                                        <InputNumber
                                                            data-testid="rlEndASpecInput"
                                                            disabled={!this.props.assembly.returnLossSideA}
                                                            value={this.props.assembly.rlEndA}
                                                            onChange={(value) => {
                                                                if (value > 9 && value < 10000) {
                                                                    this.props.updateAssembly({ rlEndA: value });
                                                                }
                                                            }}
                                                            formatter={(value) =>
                                                                `${value.toString().replace(/^[A-Za-z--]+$/, '')}`
                                                            }
                                                            min={10}
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        RL<sub>B</sub>
                                                    </td>
                                                    <td>
                                                        &ge;{' '}
                                                        <InputNumber
                                                            data-testid="rlEndBSpecInput"
                                                            disabled={!this.props.assembly.returnLossSideB}
                                                            value={this.props.assembly.rlEndB}
                                                            onChange={(value) => {
                                                                if (value > 9 && value < 10000) {
                                                                    this.props.updateAssembly({ rlEndB: value });
                                                                }
                                                            }}
                                                            formatter={(value) =>
                                                                `${value.toString().replace(/^[A-Za-z--]+$/, '')}`
                                                            }
                                                            min={10}
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        RL<sub>total</sub>
                                                    </td>
                                                    <td>
                                                        &ge;{' '}
                                                        <InputNumber
                                                            data-testid="rlTotalSpecInput"
                                                            disabled={!this.props.assembly.returnLossTotal}
                                                            value={this.props.assembly.rlTotal}
                                                            onChange={(value) => {
                                                                if (value > 0 && value < 10000) {
                                                                    this.props.updateAssembly({ rlTotal: value });
                                                                }
                                                            }}
                                                            formatter={(value) =>
                                                                `${value.toString().replace(/^[A-Za-z--]+$/, '')}`
                                                            }
                                                            min={0}
                                                        />
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="or">&nbsp;&nbsp;&nbsp;&nbsp;OR&nbsp;&nbsp;&nbsp;&nbsp;</div>
                                    <div>
                                        <table className="connectors-table">
                                            <tbody>
                                                <tr>
                                                    <td>Fiber</td>
                                                    <td>Connectors</td>
                                                </tr>

                                                <tr>
                                                    <td>End A</td>
                                                    <td>
                                                        <Select
                                                            value={this.props.assembly.connectorEndA}
                                                            onSelect={this.selectEndAConnector}
                                                            defaultValue={this.props.assembly.connectorEndA}
                                                        >
                                                            <Select.Option value={null}>&nbsp;</Select.Option>
                                                            {this.state.connectors.map((connector) => (
                                                                <Select.Option key={connector.id} value={connector.id}>
                                                                    {connector.name}
                                                                </Select.Option>
                                                            ))}
                                                        </Select>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td>End B</td>
                                                    <td>
                                                        <Select
                                                            value={this.props.assembly.connectorEndB}
                                                            onSelect={this.selectEndBConnector}
                                                            defaultValue={this.props.assembly.connectorEndB}
                                                        >
                                                            <Select.Option value={null}>&nbsp;</Select.Option>
                                                            {this.state.connectors.map((connector) => (
                                                                <Select.Option key={connector.id} value={connector.id}>
                                                                    {connector.name}
                                                                </Select.Option>
                                                            ))}
                                                        </Select>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="empty-corner" />
                                                    <td>
                                                        <Button onClick={this.showModal}> Create Connector</Button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <CreateConnectorModal
                                            isOpen={this.state.visible}
                                            il={this.state.il}
                                            rl={this.state.rl}
                                            name={this.state.name}
                                            connectors={this.state.connectors}
                                            selectedConnector={this.state.selectedConnector}
                                            updateConnectors={this.updateConnectorsFromModal}
                                            close={this.closeCreateConnectorModal}
                                        >
                                        </CreateConnectorModal>
                                    </div>

                                    <div>
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </div>

                                    {this.props.wizard.ilComp.enable && (
                                        <div>
                                            <table className="connectors-table">
                                                <tbody>
                                                    <tr>
                                                        <td>Wavelength</td>
                                                        <td>Attenuation (db/km) </td>
                                                    </tr>

                                                    {this.props.wizard.wavelength_850 && (
                                                        <tr>
                                                            <td>850</td>
                                                            <td>
                                                                <InputNumber
                                                                    value={this.props.wizard.ilComp.attenuation_850}
                                                                    onChange={(value) => {
                                                                        if (value > 0 && value < 10000) {
                                                                            this.props.updateIlComp({
                                                                                attenuation_850: value
                                                                            });
                                                                        }
                                                                    }}
                                                                    formatter={(value) =>
                                                                        `${value.toString().replace(/^[A-Za-z--]+$/, '')}`
                                                                    }
                                                                    min={0}
                                                                />
                                                            </td>
                                                        </tr>
                                                    )}
                                                    {this.props.wizard.wavelength_1300 && (
                                                        <tr>
                                                            <td>1300</td>
                                                            <td>
                                                                <InputNumber
                                                                    value={this.props.wizard.ilComp.attenuation_1300}
                                                                    onChange={(value) => {
                                                                        if (value > 0 && value < 10000) {
                                                                            this.props.updateIlComp({
                                                                                attenuation_1300: value
                                                                            });
                                                                        }
                                                                    }}
                                                                    formatter={(value) =>
                                                                        `${value.toString().replace(/^[A-Za-z--]+$/, '')}`
                                                                    }
                                                                    min={0}
                                                                />
                                                            </td>
                                                        </tr>
                                                    )}
                                                    {this.props.wizard.wavelength_1310 && (
                                                        <tr>
                                                            <td>1310</td>
                                                            <td>
                                                                <InputNumber
                                                                    value={this.props.wizard.ilComp.attenuation_1310}
                                                                    onChange={(value) => {
                                                                        if (value > 0 && value < 10000) {
                                                                            this.props.updateIlComp({
                                                                                attenuation_1310: value
                                                                            });
                                                                        }
                                                                    }}
                                                                    formatter={(value) =>
                                                                        `${value.toString().replace(/^[A-Za-z--]+$/, '')}`
                                                                    }
                                                                    min={0}
                                                                />
                                                            </td>
                                                        </tr>
                                                    )}
                                                    {this.props.wizard.wavelength_1490 && (
                                                        <tr>
                                                            <td>1490</td>
                                                            <td>
                                                                <InputNumber
                                                                    value={this.props.wizard.ilComp.attenuation_1490}
                                                                    onChange={(value) => {
                                                                        if (value > 0 && value < 10000) {
                                                                            this.props.updateIlComp({
                                                                                attenuation_1490: value
                                                                            });
                                                                        }
                                                                    }}
                                                                    formatter={(value) =>
                                                                        `${value.toString().replace(/^[A-Za-z--]+$/, '')}`
                                                                    }
                                                                    min={0}
                                                                />
                                                            </td>
                                                        </tr>
                                                    )}
                                                    {this.props.wizard.wavelength_1550 && (
                                                        <tr>
                                                            <td>1550</td>
                                                            <td>
                                                                <InputNumber
                                                                    value={this.props.wizard.ilComp.attenuation_1550}
                                                                    onChange={(value) => {
                                                                        if (value > 0 && value < 10000) {
                                                                            this.props.updateIlComp({
                                                                                attenuation_1550: value
                                                                            });
                                                                        }
                                                                    }}
                                                                    formatter={(value) =>
                                                                        `${value.toString().replace(/^[A-Za-z--]+$/, '')}`
                                                                    }
                                                                    min={0}
                                                                />
                                                            </td>
                                                        </tr>
                                                    )}
                                                    {this.props.wizard.wavelength_1625 && (
                                                        <tr>
                                                            <td>1625</td>
                                                            <td>
                                                                <InputNumber
                                                                    value={this.props.wizard.ilComp.attenuation_1625}
                                                                    onChange={(value) => {
                                                                        if (value > 0 && value < 10000) {
                                                                            this.props.updateIlComp({
                                                                                attenuation_1625: value
                                                                            });
                                                                        }
                                                                    }}
                                                                    formatter={(value) =>
                                                                        `${value.toString().replace(/^[A-Za-z--]+$/, '')}`
                                                                    }
                                                                    min={0}
                                                                />
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </React.Fragment>
                    )}
                </div>
                <div className="wizard-card">
                    {(this.props.wizard.assembly.insertionLossSideA ||
                        this.props.wizard.assembly.insertionLossSideB ||
                        this.props.wizard.assembly.returnLossSideA ||
                        this.props.wizard.assembly.returnLossSideB ||
                        this.props.wizard.assembly.insertionLossTotal ||
                        this.props.wizard.assembly.returnLossTotal) && (
                        <React.Fragment>
                            <div
                                className=" advance-tab"
                                onClick={() => {
                                    this.props.updateEquipment((state) => ({ advanced: !state.advanced }));
                                }}
                            >
                                <div className="title">
                                    Advanced {this.props.equipment.advanced ? <CaretUpOutlined /> : <CaretDownOutlined />}{' '}
                                    {(!this.props.wizard.validation.fields.riValid ||
                                        !this.props.wizard.validation.measurementPage) && (
                                        <ExclamationCircleOutlined style={{ color: '#e60013' }} />
                                    )}
                                </div>
                            </div>
                            {this.props.equipment.advanced && (
                                <div>
                                    <Tabs type="card" defaultActiveKey={TAB__FIBER_MAPPING}>
                                        <TabPane
                                            tab={
                                                <div style={{ display: 'flex' }}>
                                                    <div style={{ fontWeight: '500' }}> Fiber Specifications&nbsp;</div>({' '}
                                                    <div style={{ fontStyle: 'italic' }}> Cables:&nbsp;</div>
                                                    {this.props.wizard.cablesPerAssembly},&nbsp;
                                                    <div style={{ fontStyle: 'italic' }}> Fibers:&nbsp;</div>
                                                    {this.props.wizard.fibersPerCable} )
                                                </div>
                                            }
                                            key={TAB__FIBER_SPECIFICATIONS}
                                        >
                                            <div className="cable-sides section">
                                                {this.props.equipment.mtjConfiguration === MTJ__DOUBLE ? (
                                                    <DualSide
                                                        assembly={this.props.assembly}
                                                        fibers={
                                                            this.props.wizard.fibersPerCable *
                                                            this.props.wizard.cablesPerAssembly
                                                        }
                                                        update={this.props.updateAssembly}
                                                        connectors={this.state.connectors}
                                                        lastIndex={this.state.lastIndex}
                                                        firstIndex={this.state.firstIndex}
                                                    />
                                                ) : (
                                                    <>
                                                        {(this.props.equipment.mtjConfiguration === MTJ__SINGLE_END_A ||
                                                            this.props.equipment.mtjConfiguration ===
                                                                MTJ__SINGLE_END_A_THEN_END_B) &&
                                                            (this.props.wizard.assembly.insertionLossSideA ||
                                                                this.props.wizard.assembly.returnLossSideA) && (
                                                                <Side
                                                                    index="sideA"
                                                                    title="End A"
                                                                    fiberName="a"
                                                                    fibers={
                                                                        this.props.wizard.fibersPerCable *
                                                                        this.props.wizard.cablesPerAssembly
                                                                    }
                                                                    il={this.props.assembly.insertionLossSideA}
                                                                    rl={this.props.assembly.returnLossSideA}
                                                                    rlTotal={this.props.assembly.returnLossTotal}
                                                                    data={this.props.assembly.sideA}
                                                                    update={this.props.updateAssembly}
                                                                    connectors={this.state.connectors}
                                                                    lastIndex={this.state.lastIndex}
                                                                    firstIndex={this.state.firstIndex}
                                                                    assembly={this.props.wizard.assembly}
                                                                />
                                                            )}
                                                        {(this.props.equipment.mtjConfiguration === MTJ__SINGLE_END_B ||
                                                            this.props.equipment.mtjConfiguration ===
                                                                MTJ__SINGLE_END_A_THEN_END_B) &&
                                                            (this.props.wizard.assembly.insertionLossSideB ||
                                                                this.props.wizard.assembly.returnLossSideB) && (
                                                                <Side
                                                                    index="sideB"
                                                                    title="End B"
                                                                    fiberName="b"
                                                                    fibers={
                                                                        this.props.wizard.fibersPerCable *
                                                                        this.props.wizard.cablesPerAssembly
                                                                    }
                                                                    il={this.props.assembly.insertionLossSideB}
                                                                    rl={this.props.assembly.returnLossSideB}
                                                                    rlTotal={this.props.assembly.returnLossTotal}
                                                                    data={this.props.assembly.sideB}
                                                                    update={this.props.updateAssembly}
                                                                    connectors={this.state.connectors}
                                                                    lastIndex={this.state.lastIndex}
                                                                    firstIndex={this.state.firstIndex}
                                                                    assembly={this.props.wizard.assembly}
                                                                />
                                                            )}
                                                        {(this.props.equipment.mtjConfiguration === MTJ__SINGLE_END_A ||
                                                            this.props.equipment.mtjConfiguration === MTJ__SINGLE_END_B ||
                                                            this.props.equipment.mtjConfiguration ===
                                                                MTJ__SINGLE_END_A_THEN_END_B) &&
                                                            this.props.assembly.returnLossTotal && (
                                                                <SideRlTotal
                                                                    index="sideTotal"
                                                                    title="End B"
                                                                    fiberName=""
                                                                    fibers={
                                                                        this.props.wizard.fibersPerCable *
                                                                        this.props.wizard.cablesPerAssembly
                                                                    }
                                                                    il={this.props.assembly.insertionLossSideB}
                                                                    rl={this.props.assembly.returnLossSideB}
                                                                    rlTotal={this.props.assembly.returnLossTotal}
                                                                    data={this.props.assembly.sideB}
                                                                    update={this.props.updateAssembly}
                                                                    connectors={this.state.connectors}
                                                                    lastIndex={this.state.lastIndex}
                                                                    firstIndex={this.state.firstIndex}
                                                                />
                                                            )}
                                                    </>
                                                )}
                                            </div>
                                            {this.props.wizard.fibersPerCable * this.props.wizard.cablesPerAssembly > 12 && (
                                                <Pagination
                                                    count={Math.ceil(
                                                        (this.props.wizard.fibersPerCable *
                                                            this.props.wizard.cablesPerAssembly) /
                                                            12
                                                    )}
                                                    boundaryCount={2}
                                                    onChange={this.onChange}
                                                />
                                            )}{' '}
                                        </TabPane>
                                        <TabPane
                                            tab={
                                                <div style={{ display: 'flex' }}>
                                                    <div style={{ fontWeight: '500' }}> Fiber Mapping</div>
                                                </div>
                                            }
                                            key={TAB__FIBER_MAPPING}
                                        >
                                            <div className="section">
                                                <div className="tooltip-container">
                                                    <div>
                                                        <div className="title">
                                                            <div>
                                                                TJ<sub>1</sub> Length: &nbsp;
                                                            </div>
                                                        </div>
                                                        <div className="tooltip-container">
                                                            <Radio.Group
                                                                buttonStyle="solid"
                                                                defaultValue={this.props.equipment.tj1}
                                                                value={this.props.equipment.tj1}
                                                                onChange={(e) =>
                                                                    this.props.updateEquipment({ tj1: e.target.value })
                                                                }
                                                            >
                                                                <Tooltip
                                                                    title={
                                                                        <div>
                                                                            TJ<sub>1</sub> measured by RLM
                                                                        </div>
                                                                    }
                                                                >
                                                                    <Radio.Button value={TJ_TYPE__MEASURE}>
                                                                        Measure
                                                                    </Radio.Button>
                                                                </Tooltip>
                                                                <Tooltip
                                                                    title={
                                                                        <div>
                                                                            User will be prompted to enter TJ<sub>1</sub> length at runtime.
                                                                        </div>
                                                                    }
                                                                >
                                                                    <Radio.Button value={TJ_TYPE__USER_INPUT}>
                                                                        User Input
                                                                    </Radio.Button>
                                                                </Tooltip>
                                                                <Tooltip
                                                                    title={
                                                                        <div>
                                                                            {' '}
                                                                            TJ<sub>1</sub> preset
                                                                        </div>
                                                                    }
                                                                >
                                                                    <Radio.Button value={TJ_TYPE__MANUAL}>Manual</Radio.Button>
                                                                </Tooltip>
                                                            </Radio.Group>

                                                            {this.props.equipment.tj1 === TJ_TYPE__MANUAL && (
                                                                <React.Fragment>
                                                                    <div>&nbsp; &nbsp;</div>
                                                                    <InputNumber
                                                                        onChange={(value) => {
                                                                            let arr = [];

                                                                            arr = Array(
                                                                                this.props.equipment.tj1Length.length
                                                                            ).fill(value);
                                                                            this.props.updateEquipment({ tj1Length: arr });
                                                                        }}
                                                                        formatter={(value) =>
                                                                            `${value.replace(/^[A-Za-z--]+$/, '')}`
                                                                        }
                                                                        min={0}
                                                                        step={0.01}
                                                                    />
                                                                    &nbsp;m
                                                                </React.Fragment>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {this.props.equipment.mtjConfiguration === MTJ__DOUBLE && (
                                                <div className="section">
                                                    <div className="tooltip-container">
                                                        <div>
                                                            <div className="title">
                                                                <div>
                                                                    TJ<sub>2</sub> Length: &nbsp;
                                                                </div>
                                                            </div>
                                                            <div className="tooltip-container">
                                                                <Radio.Group
                                                                    buttonStyle="solid"
                                                                    defaultValue={this.props.equipment.tj2}
                                                                    onChange={(e) =>
                                                                        this.props.updateEquipment({ tj2: e.target.value })
                                                                    }
                                                                >
                                                                    <Tooltip
                                                                        title={
                                                                            <div>
                                                                                TJ<sub>2</sub> measured by RLM
                                                                            </div>
                                                                        }
                                                                    >
                                                                        <Radio.Button value={TJ_TYPE__AUTO}>Auto</Radio.Button>
                                                                    </Tooltip>
                                                                    <Tooltip
                                                                        title={
                                                                            <div>
                                                                                TJ<sub>2</sub> preset
                                                                            </div>
                                                                        }
                                                                    >
                                                                        <Radio.Button value={TJ_TYPE__MANUAL}>
                                                                            Manual
                                                                        </Radio.Button>
                                                                    </Tooltip>
                                                                </Radio.Group>
                                                                {this.props.equipment.tj2 === TJ_TYPE__MANUAL && (
                                                                    <React.Fragment>
                                                                        <div>&nbsp; &nbsp;</div>
                                                                        <InputNumber
                                                                            onChange={(value) => {
                                                                                let arr = [];
                                                                                arr = Array(
                                                                                    this.props.equipment.tj2Length.length
                                                                                ).fill(value);
                                                                                this.props.updateEquipment({ tj2Length: arr });
                                                                            }}
                                                                            formatter={(value) =>
                                                                                `${value.replace(/^[A-Za-z--]+$/, '')}`
                                                                            }
                                                                            min={0}
                                                                            step={0.01}
                                                                        />
                                                                        &nbsp;m
                                                                    </React.Fragment>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            <FiberMappingTable
                                                equipment={this.props.equipment}
                                                update={this.props.updateEquipment}
                                                wizard={this.props.wizard}
                                                updateWizardData={this.props.updateWizardData}
                                                lastIndex={this.state.lastIndexFiberMapping}
                                                firstIndex={this.state.firstIndexFiberMapping}
                                            />
                                            <Pagination
                                                count={Math.ceil(
                                                    this.props.equipment.mtjConfiguration === MTJ__SINGLE_END_A ||
                                                        this.props.equipment.mtjConfiguration === MTJ__SINGLE_END_B ||
                                                        this.props.equipment.mtjConfiguration === MTJ__DOUBLE
                                                        ? (this.props.wizard.fibersPerCable *
                                                              this.props.wizard.cablesPerAssembly) /
                                                              12
                                                        : (this.props.wizard.fibersPerCable *
                                                              this.props.wizard.cablesPerAssembly *
                                                              2) /
                                                              12
                                                )}
                                                boundaryCount={2}
                                                onChange={this.onChangeFiberMapping}
                                            />
                                        </TabPane>
                                        <TabPane
                                            tab={
                                                <div style={{ display: 'flex' }}>
                                                    <div style={{ fontWeight: '500' }}> Reference Mapping&nbsp;</div>
                                                </div>
                                            }
                                            key={TAB__REFERENCE_MAPPING}
                                        >
                                            <ReferenceMappingTable
                                                equipment={this.props.equipment}
                                                update={this.props.updateEquipment}
                                                wizard={this.props.wizard}
                                                updateWizardData={this.props.updateWizardData}
                                                lastIndex={this.state.lastIndexReferenceMapping}
                                                firstIndex={this.state.firstIndexReferenceMapping}
                                            />
                                            <Pagination
                                                count={Math.ceil(this.props.equipment.reference.fibers.length / 12)}
                                                boundaryCount={2}
                                                onChange={this.onChangeReferenceMapping}
                                            />
                                        </TabPane>
                                        <TabPane
                                            tab={
                                                <div style={{ display: 'flex' }}>
                                                    <div style={{ fontWeight: '500' }}> Additional Specifications&nbsp;</div>
                                                </div>
                                            }
                                            key={TAB__ADDITIONAL_SPECIFICATIONS}
                                        >
                                            <AdditionalSpecs
                                                assembly={this.props.assembly}
                                                equipment={this.props.equipment}
                                                updateWizardData={this.props.updateWizardData}
                                                wizard={this.props.wizard}
                                            />
                                        </TabPane>
                                    </Tabs>
                                </div>
                            )}
                        </React.Fragment>
                    )}
                </div>
            </div>
        );
    }
}

export class FiberMappingTable extends React.PureComponent {
    static propTypes = {
        equipment: PropTypes.object,
        update: PropTypes.func,
        wizard: PropTypes.object,
        updateWizardData: PropTypes.func
    };

    state = {
        endRadio: "ab",
        fieldChoice: "switch0",
        fiberText: "",
        fiberValue: 0,
        fiberChange: false,
        polaritySync: false
    };

    closeModifyFiberModal = () => {
        this.setState({ fiberChange: false })
    }

    render() {
        let fiberColumn = [];
        let outputColumn = [];
        let switch1Column = [];
        let switch2Column = [];
        let tj1LengthColumn = [];
        let tj2LengthColumn = [];
        let detectorColumn = [];
        let pauseBeforeColumn = [];
        let pauseMessages = [];
        let breakCable = [];
        let fibers = this.props.wizard.fibersPerCable * this.props.wizard.cablesPerAssembly;
        if (this.props.equipment.mtjConfiguration === MTJ__SINGLE_END_A_THEN_END_B) {
            fibers = fibers * 2;
        }
        for (let i = 0; i < fibers; i++) {
            let skipped = false;

            if (
                this.props.equipment.mtjConfiguration === MTJ__SINGLE_END_A ||
                this.props.equipment.mtjConfiguration === MTJ__DOUBLE
            ) {
                skipped = this.props.wizard.assembly.sideA.skip[i];
            } else if (this.props.equipment.mtjConfiguration === MTJ__SINGLE_END_B) {
                skipped = this.props.wizard.assembly.sideB.skip[i];
            } else if (this.props.equipment.mtjConfiguration === MTJ__SINGLE_END_A_THEN_END_B) {
                if (i < fibers / 2) {
                    skipped = this.props.wizard.assembly.sideA.skip[i];
                } else {
                    skipped = this.props.wizard.assembly.sideB.skip[i - fibers / 2];
                }
            }

            fiberColumn.push(
                <div key={'fiber-' + i}>
                    <Form.Item>{this.props.equipment.fibers[i]} </Form.Item>
                </div>
            );

            if (skipped) {
                outputColumn.push(<div key={'switch0-' + i}>Skipped</div>);
                switch1Column.push(<div key={'switch1-' + i}></div>);
                switch2Column.push(<div key={'switch2-' + i}></div>);
                tj1LengthColumn.push(<div key={'tj1Length-' + i}></div>);
                tj2LengthColumn.push(<div key={'tj2Length-' + i}></div>);
                detectorColumn.push(<div key={'detector-' + i}></div>);
                pauseBeforeColumn.push(<div key={'pauseBefore-' + i}></div>);
                pauseMessages.push(<div key={'pauseMessages-' + i}></div>);
                breakCable.push(<div key={'breakCable-' + i}></div>);
            } else {
                outputColumn.push(
                    <div key={'switch0-' + i}>
                        <Form.Item validateStatus={this.props.wizard.validation.fields.switch0[i] ? '' : 'error'}>
                            <InputNumber
                                className={
                                    this.props.wizard.assembly.polarity.darkChannels?.includes(i) &&
                                    this.props.wizard.assembly.testPolarity &&
                                    'dark-channel'
                                }
                                //   disabled={this.props.equipment.useSwitch1 || this.props.equipment.useSwitch2}
                                min={MIN_INTERNAL_SWITCH_CHANNEL}
                                max={MAX_INTERNAL_SWITCH_CHANNEL}
                                value={this.props.equipment.switch0[i]}
                                onChange={(value) =>
                                    this.props.update((state) => {
                                        let switch0 = [...state.switch0];
                                        switch0[i] = value;
                                        return { switch0 };
                                    })
                                }
                                precision={0}
                            />
                        </Form.Item>
                    </div>
                );

                switch1Column.push(
                    <div key={'switch1-' + i}>
                        <Form.Item
                            validateStatus={
                                this.props.equipment.useSwitch1 && this.props.equipment.useSwitch2
                                    ? (this.props.equipment.switch1[i] === null || this.props.equipment.switch1[i] === '') &&
                                      (this.props.equipment.switch2[i] === null || this.props.equipment.switch2[i] === '')
                                        ? 'error'
                                        : ''
                                    : this.props.wizard.validation.fields.switch1[i]
                                    ? ''
                                    : 'error'
                            }
                        >
                            <InputNumber
                                className={
                                    this.props.wizard.assembly.polarity.darkChannels?.includes(i) &&
                                    this.props.wizard.assembly.testPolarity &&
                                    'dark-channel'
                                }
                                min={MIN_EXTERNAL_SWITCH_CHANNEL}
                                max={MAX_EXTERNAL_SWITCH_CHANNEL}
                                value={this.props.equipment.switch1[i]}
                                onChange={(value) => {
                                    this.props.update((state) => {
                                        let switch1 = [...state.switch1];

                                        switch1[i] = value;

                                        return { switch1 };
                                    });
                                }}
                                precision={0}
                                style={{
                                    borderColor:
                                        this.props.equipment.switch0[i] === 1 &&
                                        this.props.wizard.validation.fields.switch1[i] &&
                                        '#43B02A'
                                }}
                            />
                        </Form.Item>
                    </div>
                );

                switch2Column.push(
                    <div key={'switch2-' + i}>
                        <Form.Item
                            validateStatus={
                                this.props.equipment.useSwitch1 && this.props.equipment.useSwitch2
                                    ? (this.props.equipment.switch1[i] === null || this.props.equipment.switch1[i] === '') &&
                                      (this.props.equipment.switch2[i] === null || this.props.equipment.switch2[i] === '')
                                        ? 'error'
                                        : ''
                                    : this.props.wizard.validation.fields.switch2[i]
                                    ? ''
                                    : 'error'
                            }
                        >
                            <InputNumber
                                className={
                                    this.props.wizard.assembly.polarity.darkChannels?.includes(i) &&
                                    this.props.wizard.assembly.testPolarity &&
                                    'dark-channel'
                                }
                                min={MIN_EXTERNAL_SWITCH_CHANNEL}
                                max={MAX_EXTERNAL_SWITCH_CHANNEL}
                                value={this.props.equipment.switch2[i]}
                                onChange={(value) =>
                                    this.props.update((state) => {
                                        let switch2 = [...state.switch2];

                                        switch2[i] = value;
                                        return { switch2 };
                                    })
                                }
                                precision={0}
                                style={{
                                    borderColor:
                                        this.props.equipment.switch2[i] === null
                                            ? 'red'
                                            : this.props.equipment.switch0[i] === 2 &&
                                              this.props.wizard.validation.fields.switch2[i] &&
                                              '#43B02A'
                                }}
                            />
                        </Form.Item>
                    </div>
                );

                tj1LengthColumn.push(
                    <div key={'tj1Length-' + i}>
                        <Form.Item>
                            <InputNumber
                                className={
                                    this.props.wizard.assembly.polarity.darkChannels?.includes(i) &&
                                    this.props.wizard.assembly.testPolarity &&
                                    'dark-channel'
                                }
                                min={0}
                                step={0.01}
                                value={this.props.equipment.tj1Length[i]}
                                onChange={(value) =>
                                    this.props.update((state) => {
                                        let tj1Length = [...state.tj1Length];
                                        tj1Length[i] = value;
                                        return { tj1Length };
                                    })
                                }
                                style={{
                                    borderColor:
                                        this.props.equipment.tj1Length[i] === undefined ||
                                        this.props.equipment.tj1Length[i] === null
                                            ? '#e60013'
                                            : ''
                                }}
                            />
                            &nbsp;m
                        </Form.Item>
                    </div>
                );

                tj2LengthColumn.push(
                    <div key={'tj2Length-' + i}>
                        <Form.Item>
                            <InputNumber
                                className={
                                    this.props.wizard.assembly.polarity.darkChannels?.includes(i) &&
                                    this.props.wizard.assembly.testPolarity &&
                                    'dark-channel'
                                }
                                min={0}
                                step={0.01}
                                value={this.props.equipment.tj2Length[i]}
                                onChange={(value) =>
                                    this.props.update((state) => {
                                        let tj2Length = [...state.tj2Length];
                                        tj2Length[i] = value;
                                        return { tj2Length };
                                    })
                                }
                                style={{
                                    borderColor:
                                        this.props.equipment.tj2Length[i] === undefined ||
                                        this.props.equipment.tj2Length[i] === null
                                            ? '#e60013'
                                            : ''
                                }}
                            />
                            &nbsp;m
                        </Form.Item>
                    </div>
                );

                detectorColumn.push(
                    <div key={'detector-' + i}>
                        <Form.Item>
                            <InputNumber
                                className={
                                    this.props.wizard.assembly.polarity.darkChannels?.includes(i) &&
                                    this.props.wizard.assembly.testPolarity &&
                                    'dark-channel'
                                }
                                min={1}
                                step={1}
                                defaultValue={this.props.equipment.detectors[i]}
                                value={this.props.equipment.detectors[i]}
                                onChange={(value) =>
                                    this.props.update((state) => {
                                        let detectors = [...state.detectors];
                                        detectors[i] = value;
                                        return { detectors };
                                    })
                                }
                            />
                        </Form.Item>
                    </div>
                );

                pauseBeforeColumn.push(
                    <div key={'pauseBefore-' + i}>
                        <Form.Item>
                            <Checkbox
                                data-testid={`pause-before-checkbox-${i}`}
                                checked={this.props.equipment.pauseBefore[i]}
                                onChange={(e) => {
                                    // Store value now - event value is cleared before update callback is called
                                    const checked = e.target.checked;
                                    this.props.update((state) => {
                                        let pauseBefore = [...state.pauseBefore];
                                        pauseBefore[i] = checked;
                                        return { pauseBefore };
                                    });
                                }}
                            />
                        </Form.Item>
                    </div>
                );
                breakCable.push(
                    <div key={'breakCable-' + i}>
                        <Form.Item>
                            <Checkbox
                                data-testid={`new-cable-checkbox-${i}`}
                                checked={this.props.equipment.breakCable[this.props.equipment.fibers[i]]}
                                onChange={(e) => {
                                    // Store value now - event value is cleared before update callback is called
                                    const checked = e.target.checked;
                                    this.props.update((state) => {
                                        let breakCable = { ...state.breakCable };

                                        breakCable[this.props.equipment.fibers[i]] = checked;

                                        return { breakCable };
                                    });
                                }}
                            />
                        </Form.Item>
                    </div>
                );

                pauseMessages.push(
                    <div key={'pauseMessages-' + i}>
                        <Form.Item>
                            <Input
                                className={
                                    this.props.wizard.assembly.polarity.darkChannels?.includes(i) &&
                                    this.props.wizard.assembly.testPolarity &&
                                    'dark-channel'
                                }
                                defaultValue={this.props.equipment.pauseMessages[i]}
                                maxLength={90}
                                onChange={(e) => {
                                    // Store value now - event value is cleared before update callback is called
                                    const newValue = e.target.value ?? '';

                                  this.props.update((state) => {
                                        let pauseMessages = [...state.pauseMessages];
                                        pauseMessages[i] = newValue;
                                        return { pauseMessages };
                                    });
                                }}
                            />
                        </Form.Item>
                    </div>
                );
            }
        }

        return (
            <React.Fragment key={this.props.wizard.rerenderFiberMap}>
                <ModifyFibersModal
                    isOpen={this.state.fiberChange}
                    useSwitch1={this.props.equipment.useSwitch1}
                    useSwitch2={this.props.equipment.useSwitch2}
                    showDetectors={this.props.equipment.showDetectors}
                    fiberText={this.state.fiberText}
                    endRadio={this.state.endRadio}
                    fiberValue={this.state.fiberValue}
                    fieldChoice={this.state.fieldChoice}
                    update={this.props.update}
                    fibers={this.props.equipment.fibers}
                    close={this.closeModifyFiberModal}
                >
                </ModifyFibersModal>
                <SyncPolarityModal
                    isOpen={this.state.polaritySync}
                    polarityMap={this.props.wizard.assembly?.polarity?.mapping}
                    fibersPerCable={this.props.wizard.fibersPerCable}
                    close={() => this.setState({polaritySync: false})}
                    update={this.props.update}
                >
                </SyncPolarityModal>
                <div className="float-container">
                    <div className="float-child" >
                        <div className="title">Fiber Mapping:</div>
                        <div>
                            <Checkbox
                                checked={this.props.equipment.useSwitch1}
                                onChange={(e) => this.props.update({ useSwitch1: e.target.checked })}
                            >
                                Add Switch #1
                            </Checkbox>
                        </div>
                        {this.props.wizard.testPlanTemplate !== TEST_PLAN_TEMPLATE__SIMPLEX && (
                            <div>
                                <Checkbox
                                    checked={this.props.equipment.useSwitch2}
                                    onChange={(e) => this.props.update({ useSwitch2: e.target.checked })}
                                >
                                    Add Switch #2
                                </Checkbox>
                            </div>
                        )}
                        <div>
                            <div style={{whiteSpace: 'nowrap', display: 'inline-block'}}>
                                <Checkbox 
                                    checked={this.props.equipment.showDetectors}
                                    onChange={(e) => this.props.update({ showDetectors: e.target.checked })}
                                >
                                    Add Detector Mapping
                                </Checkbox>
                                <Button  disabled={!this.props.equipment.showDetectors || !this.props.wizard.assembly.testPolarity} onClick={() => this.setState({ polaritySync: true })}>
                                    Sync with Polarity
                                </Button>
                            </div>
                        </div>
                        <div>
                            <Checkbox
                                checked={this.props.wizard.showCableBreak}
                                onChange={(e) => this.props.updateWizardData({ showCableBreak: e.target.checked })}
                            >
                                Show Cables
                            </Checkbox>
                        </div>
                        <div
                            className="fiber-mapping"
                            style={{
                                gridTemplateRows:
                                    fibers > 12
                                        ? 'repeat(' + (this.props.lastIndex - this.props.firstIndex + 1) + ', auto)'
                                        : 'repeat(' + (fibers + 1) + ', auto)'
                            }}
                        >
                            <div className="column-header">Fiber</div>
                            {Object.keys(fiberColumn)
                                .slice(this.props.firstIndex, this.props.lastIndex)
                                .map((key) => (
                                    <React.Fragment key={'fiberColumn-' + key}>{fiberColumn[key]}</React.Fragment>
                                ))}
                            <div className="column-header">Output</div>
                            {Object.keys(outputColumn)
                                .slice(this.props.firstIndex, this.props.lastIndex)
                                .map((key) => (
                                    <React.Fragment key={'output-' + key}>{outputColumn[key]}</React.Fragment>
                                ))}
                            {this.props.equipment.useSwitch1 && (
                                <React.Fragment>
                                    <div className="column-header">Switch #1</div>
                                    {Object.keys(switch1Column)
                                        .slice(this.props.firstIndex, this.props.lastIndex)
                                        .map((key) => (
                                            <React.Fragment key={'switch1-' + key}>{switch1Column[key]}</React.Fragment>
                                        ))}
                                </React.Fragment>
                            )}
                            {this.props.equipment.useSwitch2 && (
                                <React.Fragment>
                                    <div className="column-header">Switch #2</div>
                                    {Object.keys(switch2Column)
                                        .slice(this.props.firstIndex, this.props.lastIndex)
                                        .map((key) => (
                                            <React.Fragment key={'switch2-' + key}>{switch2Column[key]}</React.Fragment>
                                        ))}
                                </React.Fragment>
                            )}
                            {this.props.wizard.required.tj1Length && this.props.equipment.tj1 === TJ_TYPE__MANUAL && (
                                <React.Fragment>
                                    <div className="column-header">
                                        TJ<sub>1</sub> Length
                                    </div>
                                    {Object.keys(tj1LengthColumn)
                                        .slice(this.props.firstIndex, this.props.lastIndex)
                                        .map((key) => (
                                            <React.Fragment key={'tj1-' + key}>{tj1LengthColumn[key]}</React.Fragment>
                                        ))}
                                </React.Fragment>
                            )}
                            {this.props.wizard.required.tj2Length && this.props.equipment.tj2 === TJ_TYPE__MANUAL && (
                                <React.Fragment>
                                    <div className="column-header">
                                        TJ<sub>2</sub> Length
                                    </div>
                                    {Object.keys(tj2LengthColumn)
                                        .slice(this.props.firstIndex, this.props.lastIndex)
                                        .map((key) => (
                                            <React.Fragment key={'tj2-' + key}>{tj2LengthColumn[key]}</React.Fragment>
                                        ))}
                                </React.Fragment>
                            )}
                            {this.props.equipment.showDetectors && (
                                <React.Fragment>
                                    <div className="column-header">Detector</div>
                                    {Object.keys(detectorColumn)
                                        .slice(this.props.firstIndex, this.props.lastIndex)
                                        .map((key) => (
                                            <React.Fragment key={'detector-' + key}>{detectorColumn[key]}</React.Fragment>
                                        ))}
                                </React.Fragment>
                            )}
                            <div className="column-header">
                                Pause Before &nbsp;
                                <Checkbox
                                    onChange={(e) => {
                                        // Store value now - event value is cleared before update callback is called
                                        const checked = e.target.checked;
                                        this.props.update((state) => {
                                            let pauseBefore = [...state.pauseBefore];
                                            pauseBefore.fill(checked);

                                            return { pauseBefore };
                                        });
                                    }}
                                />{' '}
                            </div>
                            {Object.keys(pauseBeforeColumn)
                                .slice(this.props.firstIndex, this.props.lastIndex)
                                .map((key) => (
                                    <React.Fragment key={'pauseBefore-' + key}>{pauseBeforeColumn[key]}</React.Fragment>
                                ))}
                            <div className="column-header">Pause Messages</div>

                            {Object.keys(pauseMessages)
                                .slice(this.props.firstIndex, this.props.lastIndex)
                                .map((key) => (
                                    <React.Fragment key={'pauseMessages-' + key}>{pauseMessages[key]}</React.Fragment>
                                ))}
                            {this.props.wizard.showCableBreak && (
                                <React.Fragment>
                                    <div className="column-header">
                                        New Cable &nbsp;
                                        <Checkbox
                                            onChange={(e) => {
                                                // Store value now - event value is cleared before update callback is called
                                                const checked = e.target.checked;
                                                this.props.update((state) => {
                                                    let breakCable = { ...state.breakCable };
                                                    Object.keys(breakCable).forEach((v) => (breakCable[v] = checked));

                                                    return { breakCable };
                                                });
                                            }}
                                        />
                                    </div>
                                    {Object.keys(breakCable)
                                        .slice(this.props.firstIndex, this.props.lastIndex)
                                        .map((key) => (
                                            <React.Fragment key={'cableBreak-' + key}>{breakCable[key]}</React.Fragment>
                                        ))}
                                </React.Fragment>
                            )}
                        </div>
                    </div>
                    <div className="float-child" >
                        <Button onClick={() => this.setState({ fiberChange: true })}>
                            Modify Multiple Fibers
                        </Button>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

class ReferenceMappingTable extends React.PureComponent {
    static propTypes = {
        equipment: PropTypes.object,
        update: PropTypes.func,
        wizard: PropTypes.object,
        updateWizardData: PropTypes.func
    };

    render() {
        let gridTemplateColumns =
            this.props.equipment.useSwitch1 && this.props.equipment.useSwitch2
                ? 'repeat(7, max-content)'
                : this.props.equipment.useSwitch1
                ? 'repeat(6, max-content)'
                : this.props.equipment.useSwitch2
                ? 'repeat(6, max-content)'
                : 'repeat(5, max-content)';

        return (
            <div className="section">
                <div className="title">Reference Mapping:</div>
                <Checkbox
                    checked={this.props.equipment.referenceOnlyOnDetector1}
                    onChange={(e) => this.props.update({ referenceOnlyOnDetector1: e.target.checked })}
                >
                    Reference Only on Detector 1
                </Checkbox>
                <div className="reference-mapping" style={{ gridTemplateColumns }}>
                    <div className="column-header">Fiber</div>
                    <div className="column-header">Output</div>
                    {this.props.equipment.useSwitch1 && <div className="column-header">Switch #1</div>}
                    {this.props.equipment.useSwitch2 && <div className="column-header">Switch #2</div>}

                    <div className="column-header">Detector</div>
                    <div className="column-header">Pause Before</div>
                    <div className="column-header">Pause Messages</div>

                    {[...this.props.equipment.reference.fibers.slice(this.props.firstIndex, this.props.lastIndex)].map(
                        (fiberName, index) => (
                            <React.Fragment key={index}>
                                <div>{fiberName}</div>
                                {this.props.equipment.reference.skip.slice(this.props.firstIndex, this.props.lastIndex)[
                                    index
                                ] ? (
                                    <React.Fragment>
                                        <div>Skipped</div>
                                        {this.props.equipment.useSwitch1 && <div />}
                                        <div />
                                    </React.Fragment>
                                ) : (
                                    <React.Fragment>
                                            <div>
                                                {
                                                    this.props.equipment.reference.switch0.slice(
                                                        this.props.firstIndex,
                                                        this.props.lastIndex
                                                    )[index]
                                                }
                                            </div>
                                        {this.props.equipment.useSwitch1 && (
                                            <div>
                                                {
                                                    this.props.equipment.reference.switch1.slice(
                                                        this.props.firstIndex,
                                                        this.props.lastIndex
                                                    )[index]
                                                }
                                            </div>
                                        )}
                                        {this.props.equipment.useSwitch2 && (
                                            <div>
                                                {
                                                    this.props.equipment.reference.switch2.slice(
                                                        this.props.firstIndex,
                                                        this.props.lastIndex
                                                    )[index]
                                                }
                                            </div>
                                        )}

                                        <div>
                                            {
                                                this.props.equipment.reference.detectors.slice(
                                                    this.props.firstIndex,
                                                    this.props.lastIndex
                                                )[index]
                                            }
                                        </div>
                                    </React.Fragment>
                                )}
                                <div>
                                    <Checkbox
                                        tabIndex={index + this.props.firstIndex + 1}
                                        checked={
                                            this.props.equipment.reference.pauseBefore.slice(
                                                this.props.firstIndex,
                                                this.props.lastIndex
                                            )[index]
                                        }
                                        onChange={(e) => {
                                            let checked = e.target.checked;
                                            this.props.update((state) => {
                                                let pauseBefore = [...state.reference.pauseBefore];
                                                pauseBefore[this.props.firstIndex + index] = checked;
                                                return {
                                                    reference: {
                                                        ...state.reference,
                                                        pauseBefore
                                                    }
                                                };
                                            });
                                        }}
                                    />
                                </div>
                                <div>
                                    <Input
                                        tabIndex={index + this.props.lastIndex + 1}
                                        value={
                                            this.props.equipment.reference.pauseMessages.slice(
                                                this.props.firstIndex,
                                                this.props.lastIndex
                                            )[index] === undefined
                                                ? ''
                                                : this.props.equipment.reference.pauseMessages.slice(
                                                      this.props.firstIndex,
                                                      this.props.lastIndex
                                                  )[index]
                                        }
                                        maxLength={90}
                                        onChange={(e, value) => {
                                            let pause = e.target.value;
                                            this.props.update((state) => {
                                                let pauseMessages = [...state.reference.pauseMessages];
                                                pauseMessages[this.props.firstIndex + index] = pause;
                                                return {
                                                    reference: {
                                                        ...state.reference,
                                                        pauseMessages
                                                    }
                                                };
                                            });
                                        }}
                                    />
                                </div>
                            </React.Fragment>
                        )
                    )}
                </div>
            </div>
        );
    }
}

class Side extends React.PureComponent {
    state = {
        tableIndex: 0
    };

    static propTypes = {
        title: PropTypes.string,
        fiberName: PropTypes.string,
        index: PropTypes.string,
        fibers: PropTypes.number,
        il: PropTypes.bool,
        rl: PropTypes.bool,
        rlTotal: PropTypes.bool,
        data: PropTypes.object,
        update: PropTypes.func,
        connectors: PropTypes.array
    };

    render() {
        let fiberColumn = [];
        let skipColumn = [];
        let ilColumn = [];
        let rlColumn = [];
        let rlTotalColumn = [];
        for (let i = 0; i < this.props.fibers; i++) {
            // Prepare the Fiber column
            fiberColumn.push(
                <div
                    key={'fiber-' + i}
                    style={{
                        background:
                            this.props.assembly.polarity.darkChannels?.includes(i) &&
                            this.props.assembly.testPolarity &&
                            this.props.fiberName === 'a' &&
                            '#aaaaaa'
                    }}
                >
                    {i + 1}
                    {this.props.fiberName}
                </div>
            );

            // Prepare the Skip column
            skipColumn.push(
                <div key={'skip-' + i}>
                    <Checkbox
                        checked={this.props.data.skip[i]}
                        onChange={(e) =>
                            this.props.update((state) => {
                                let skip = [...state[this.props.index].skip];
                                skip[i] = e.target.checked;

                                return {
                                    [this.props.index]: {
                                        ...state[this.props.index],
                                        skip: skip
                                    }
                                };
                            })
                        }
                    />
                </div>
            );

            // Prepare the IL column
            ilColumn.push(
                <div key={'il-' + i}>
                    {!this.props.data.skip[i] && (
                        <React.Fragment>
                            &le;&nbsp;
                            <InputNumber
                                value={this.props.data.il[i]}
                                onChange={(value) => {
                                    this.props.update((state) => {
                                        let il = [...state[this.props.index].il];
                                        il[i] = value;

                                        return {
                                            [this.props.index]: {
                                                ...state[this.props.index],
                                                il: il
                                            }
                                        };
                                    });
                                }}
                                style={{
                                    borderColor:
                                        this.props.data.il[i] === undefined || this.props.data.il[i] === null ? '#e60013' : '',
                                    background:
                                        this.props.assembly.polarity.darkChannels?.includes(i) &&
                                        this.props.assembly.testPolarity &&
                                        this.props.fiberName === 'a' &&
                                        '#aaaaaa'
                                }}
                            />
                            &nbsp;dB
                        </React.Fragment>
                    )}
                </div>
            );

            rlColumn.push(
                <div key={'rl-' + i}>
                    {!this.props.data.skip[i] && (
                        <React.Fragment>
                            &ge;&nbsp;
                            <InputNumber
                                value={this.props.data.rl[i]}
                                onChange={(value) => {
                                    this.props.update((state) => {
                                        let rl = [...state[this.props.index].rl];
                                        rl[i] = value;

                                        return {
                                            [this.props.index]: {
                                                ...state[this.props.index],
                                                rl: rl
                                            }
                                        };
                                    });
                                }}
                                style={{
                                    borderColor:
                                        this.props.data.rl[i] === undefined || this.props.data.rl[i] === null ? '#e60013' : '',
                                    background:
                                        this.props.assembly.polarity.darkChannels?.includes(i) &&
                                        this.props.assembly.testPolarity &&
                                        this.props.fiberName === 'a' &&
                                        '#aaaaaa'
                                }}
                            />
                            &nbsp;dB
                        </React.Fragment>
                    )}
                </div>
            );

            rlTotalColumn.push(
                <div key={'rltotal' + i}>
                    {!this.props.data.skip[i] && (
                        <React.Fragment>
                            &ge;&nbsp;
                            <InputNumber
                                value={this.props.data.rlTotal[i]}
                                onChange={(value) => {
                                    this.props.update((state) => {
                                        let rlTotal = [...state[this.props.index].rlTotal];
                                        rlTotal[i] = value;

                                        return {
                                            [this.props.index]: {
                                                ...state[this.props.index],
                                                rlTotal: rlTotal
                                            }
                                        };
                                    });
                                }}
                                style={{
                                    borderColor:
                                        this.props.data.rlTotal[i] === undefined || this.props.data.rlTotal[i] === null
                                            ? '#e60013'
                                            : '',
                                    background:
                                        this.props.assembly.polarity.darkChannels?.includes(i) &&
                                        this.props.assembly.testPolarity &&
                                        this.props.fiberName === 'a' &&
                                        '#aaaaaa'
                                }}
                            />
                            &nbsp;dB
                        </React.Fragment>
                    )}
                </div>
            );
        }

        return (
            <div className="side">
                <div className="title">{this.props.title}</div>

                <div
                    className="fiber-table"
                    style={{
                        gridTemplateRows:
                            this.props.fibers > 12
                                ? 'repeat(' + (this.props.lastIndex - this.props.firstIndex + 1) + ', auto)'
                                : 'repeat(' + (this.props.fibers + 1) + ', auto)'
                    }}
                >
                    <div>Fiber</div>

                    {Object.keys(fiberColumn)
                        .slice(this.props.firstIndex, this.props.lastIndex)
                        .map((key) => (
                            <React.Fragment key={'fiber-' + key}>{fiberColumn[key]}</React.Fragment>
                        ))}
                    <React.Fragment key={this.state.tableIndex}>
                        {this.props.il && (
                            <React.Fragment>
                                <div>IL</div>
                                {Object.keys(ilColumn)
                                    .slice(this.props.firstIndex, this.props.lastIndex)
                                    .map((key) => (
                                        <React.Fragment key={'il-' + key}>{ilColumn[key]}</React.Fragment>
                                    ))}
                            </React.Fragment>
                        )}
                        {this.props.rl && (
                            <React.Fragment>
                                <div>RL</div>
                                {Object.keys(rlColumn)
                                    .slice(this.props.firstIndex, this.props.lastIndex)
                                    .map((key) => (
                                        <React.Fragment key={'rl-' + key}>{rlColumn[key]}</React.Fragment>
                                    ))}
                            </React.Fragment>
                        )}
                    </React.Fragment>
                </div>
            </div>
        );
    }
}
class SideRlTotal extends React.PureComponent {
    state = {
        tableIndex: 0
    };

    static propTypes = {
        title: PropTypes.string,
        fiberName: PropTypes.string,
        index: PropTypes.string,
        fibers: PropTypes.number,
        il: PropTypes.bool,
        rl: PropTypes.bool,
        rlTotal: PropTypes.bool,
        data: PropTypes.object,
        update: PropTypes.func,
        connectors: PropTypes.array
    };

    render() {
        let fiberColumn = [];
        let skipColumn = [];

        let rlTotalColumn = [];

        for (let i = 0; i < this.props.fibers; i++) {
            // Prepare the Fiber column
            fiberColumn.push(
                <div key={'fiber-' + i} className="col-fiber">
                    {i + 1}
                    {this.props.fiberName}
                </div>
            );

            // Prepare the Skip column
            skipColumn.push(
                <div key={'skip-' + i}>
                    <Checkbox
                        checked={this.props.data.skip[i]}
                        onChange={(e) =>
                            this.props.update((state) => {
                                let skip = [...state[this.props.index].skip];
                                skip[i] = e.target.checked;

                                return {
                                    [this.props.index]: {
                                        ...state[this.props.index],
                                        skip: skip
                                    }
                                };
                            })
                        }
                    />
                </div>
            );

            rlTotalColumn.push(
                <div key={'rltotal' + i}>
                    {!this.props.data.skip[i] && (
                        <React.Fragment>
                            &ge;&nbsp;
                            <InputNumber
                                value={this.props.data.rlTotal[i]}
                                onChange={(value) => {
                                    this.props.update((state) => {
                                        let rlTotal = [...state[this.props.index].rlTotal];
                                        rlTotal[i] = value;

                                        return {
                                            [this.props.index]: {
                                                ...state[this.props.index],
                                                rlTotal: rlTotal
                                            }
                                        };
                                    });
                                }}
                                style={{
                                    borderColor:
                                        this.props.data.rlTotal[i] === undefined || this.props.data.rlTotal[i] === null
                                            ? '#e60013'
                                            : ''
                                }}
                            />
                            &nbsp;dB
                        </React.Fragment>
                    )}
                </div>
            );
        }

        return (
            <div className="side">
                <div className="title">DUT (Connectors + Fiber)</div>
                <div
                    className="fiber-table"
                    style={{
                        gridTemplateRows:
                            this.props.fibers > 12
                                ? 'repeat(' + (this.props.lastIndex - this.props.firstIndex + 1) + ', auto)'
                                : 'repeat(' + (this.props.fibers + 1) + ', auto)'
                    }}
                >
                    <div>Fiber</div>

                    {Object.keys(fiberColumn)
                        .slice(this.props.firstIndex, this.props.lastIndex)
                        .map((key) => (
                            <React.Fragment key={'fiber-' + key}>{fiberColumn[key]}</React.Fragment>
                        ))}
                    <React.Fragment key={this.state.tableIndex}>
                        {this.props.rlTotal && (
                            <React.Fragment>
                                <div>
                                    RL<sub>TOTAL</sub>
                                </div>
                                {Object.keys(rlTotalColumn)
                                    .slice(this.props.firstIndex, this.props.lastIndex)
                                    .map((key) => (
                                        <React.Fragment key={'rltotal-' + key}>{rlTotalColumn[key]}</React.Fragment>
                                    ))}
                            </React.Fragment>
                        )}
                    </React.Fragment>
                </div>
            </div>
        );
    }
}

class DualSide extends React.PureComponent {
    state = {
        tableIndex: 0
    };

    static propTypes = {
        fibers: PropTypes.number,
        assembly: PropTypes.object,
        update: PropTypes.func,
        connectors: PropTypes.array
    };

    render() {
        let fiberColumn = [];
        let ilColumn = [];
        let rlColumnA = [];
        let rlColumnB = [];
        let rlTotalColumn = [];

        for (let i = 0; i < this.props.fibers; i++) {
            // Prepare the Fiber column
            fiberColumn.push(
                <div key={'fiber-' + i} className="col-fiber">
                    {i + 1}
                    a/b
                </div>
            );

            // Prepare the IL column
            ilColumn.push(
                <div key={'il-' + i}>
                    {!this.props.assembly.sideA.skip[i] && (
                        <React.Fragment>
                            &le;&nbsp;
                            <InputNumber
                                value={this.props.assembly.ilTotalList[i]}
                                onChange={(value) => {
                                    this.props.update((state) => {
                                        let ilTotalList = [...state.ilTotalList];
                                        ilTotalList[i] = value;

                                        return {
                                            ...state,
                                            ilTotalList: ilTotalList
                                        };
                                    });
                                }}
                                style={{
                                    borderColor:
                                        this.props.assembly.ilTotalList[i] === undefined ||
                                        this.props.assembly.ilTotalList[i] === null
                                            ? '#e60013'
                                            : ''
                                }}
                            />
                            &nbsp;dB
                        </React.Fragment>
                    )}
                </div>
            );

            rlColumnA.push(
                <div key={'rl-' + i}>
                    {!this.props.assembly.sideA.skip[i] && (
                        <React.Fragment>
                            &ge;&nbsp;
                            <InputNumber
                                value={this.props.assembly.sideA.rl[i]}
                                onChange={(value) => {
                                    this.props.update((state) => {
                                        let rl = [...state.sideA.rl];
                                        rl[i] = value;

                                        return {
                                            sideA: {
                                                ...state.sideA,
                                                rl: rl
                                            }
                                        };
                                    });
                                }}
                                style={{
                                    borderColor:
                                        this.props.assembly.sideA.rl[i] === undefined ||
                                        this.props.assembly.sideA.rl[i] === null
                                            ? '#e60013'
                                            : ''
                                }}
                            />
                            &nbsp;dB
                        </React.Fragment>
                    )}
                </div>
            );
            rlColumnB.push(
                <div key={'rl-' + i}>
                    {!this.props.assembly.sideA.skip[i] && (
                        <React.Fragment>
                            &ge;&nbsp;
                            <InputNumber
                                value={this.props.assembly.sideB.rl[i]}
                                onChange={(value) => {
                                    this.props.update((state) => {
                                        let rl = [...state.sideB.rl];
                                        rl[i] = value;

                                        return {
                                            sideB: {
                                                ...state.sideB,
                                                rl: rl
                                            }
                                        };
                                    });
                                }}
                                style={{
                                    borderColor:
                                        this.props.assembly.sideB.rl[i] === undefined ||
                                        this.props.assembly.sideB.rl[i] === null
                                            ? '#e60013'
                                            : ''
                                }}
                            />
                            &nbsp;dB
                        </React.Fragment>
                    )}
                </div>
            );

            rlTotalColumn.push(
                <div key={'rltotal' + i}>
                    {!this.props.assembly.sideA.skip[i] && (
                        <React.Fragment>
                            &ge;&nbsp;
                            <InputNumber
                                value={this.props.assembly.sideA.rlTotal[i]}
                                onChange={(value) => {
                                    this.props.update((state) => {
                                        let rlTotal = [...state.sideA.rlTotal];
                                        rlTotal[i] = value;

                                        return {
                                            sideA: {
                                                ...state.sideA,
                                                rlTotal: rlTotal
                                            }
                                        };
                                    });
                                }}
                                style={{
                                    borderColor:
                                        this.props.assembly.sideA.rlTotal[i] === undefined ||
                                        this.props.assembly.sideA.rlTotal[i] === null
                                            ? '#e60013'
                                            : ''
                                }}
                            />
                            &nbsp;dB
                        </React.Fragment>
                    )}
                </div>
            );
        }

        return (
            <div className="side">
                <div className="title"></div>
                <div
                    className="fiber-table"
                    style={{
                        gridTemplateRows:
                            this.props.fibers > 12
                                ? 'repeat(' + (this.props.lastIndex - this.props.firstIndex + 1) + ', auto)'
                                : 'repeat(' + (this.props.fibers + 1) + ', auto)'
                    }}
                >
                    <div>Fiber</div>
                    {Object.keys(fiberColumn)
                        .slice(this.props.firstIndex, this.props.lastIndex)
                        .map((key) => (
                            <React.Fragment key={'fiber-' + key}> {fiberColumn[key]}</React.Fragment>
                        ))}
                    <React.Fragment key={this.state.tableIndex}>
                        {this.props.assembly.returnLossSideA && (
                            <React.Fragment>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <div className="title"> End A </div>
                                    <div>
                                        RL<sub>A</sub>
                                    </div>
                                </div>
                                {Object.keys(rlColumnA)
                                    .slice(this.props.firstIndex, this.props.lastIndex)
                                    .map((key) => (
                                        <React.Fragment key={'rla-' + key}> {rlColumnA[key]}</React.Fragment>
                                    ))}
                            </React.Fragment>
                        )}
                        {this.props.assembly.returnLossSideB && (
                            <React.Fragment>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <div className="title"> End B</div>
                                    <div>
                                        RL<sub>B</sub>
                                    </div>
                                </div>
                                {Object.keys(rlColumnB)
                                    .slice(this.props.firstIndex, this.props.lastIndex)
                                    .map((key) => (
                                        <React.Fragment key={'rlb-' + key}> {rlColumnB[key]}</React.Fragment>
                                    ))}
                            </React.Fragment>
                        )}
                        {this.props.assembly.insertionLossTotal && (
                            <React.Fragment>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <div className="title"> DUT (Connectors + Fiber) </div>

                                    <div>
                                        IL<sub>TOTAL</sub>
                                    </div>
                                </div>
                                {Object.keys(ilColumn)
                                    .slice(this.props.firstIndex, this.props.lastIndex)
                                    .map((key) => (
                                        <div key={'iltotal-' + key} style={{ marginRight: '50%' }}>
                                            {' '}
                                            {ilColumn[key]}
                                        </div>
                                    ))}
                            </React.Fragment>
                        )}
                        {this.props.assembly.returnLossTotal && (
                            <React.Fragment>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    {!this.props.assembly.insertionLossTotal ? (
                                        <div className="title"> DUT (Connectors + Fiber) </div>
                                    ) : (
                                        <div>&nbsp;</div>
                                    )}
                                    <div>
                                        RL<sub>TOTAL</sub>
                                    </div>
                                </div>
                                {Object.keys(rlTotalColumn)
                                    .slice(this.props.firstIndex, this.props.lastIndex)
                                    .map((key) => (
                                        <div
                                            key={'rltotal-' + key}
                                            style={{ marginRight: !this.props.assembly.insertionLossTotal && '50%' }}
                                        >
                                            {' '}
                                            {rlTotalColumn[key]}
                                        </div>
                                    ))}
                            </React.Fragment>
                        )}
                    </React.Fragment>
                </div>
            </div>
        );
    }
}

class AdditionalSpecs extends React.PureComponent {
    static propTypes = {
        assembly: PropTypes.object,
        equipment: PropTypes.object,
        updateWizardData: PropTypes.func
    };
    componentDidMount() {
        this.setState({ additionalSpecs: this.props.wizard.additionalSpecs });
    }
    getData(input) {
        let m = [], // an array to collect the strings that are found
            rxps = /:([^:]+)}/g,
            strs = input,
            curMatchs;

        while ((curMatchs = rxps.exec(strs))) {
            m.push(curMatchs[1]);
        }

        let uniqueM = [...new Set(m)];

        let found = [], // an array to collect the strings that are found
            rxp = /{([^}]+)}/g,
            str = input,
            curMatch;

        while ((curMatch = rxp.exec(str))) {
            found.push(curMatch[1]);
        }
        let temp = found[0];

        var wls = [], // an array to collect the strings that are found
            rxp1 = /:([^:]+):/g,
            str1 = input,
            curMatch1;

        while ((curMatch1 = rxp1.exec(str1))) {
            wls.push(curMatch1[1]);
        }
        let wlsInt = wls.map(Number);

        let uniqueChars = [...new Set(wlsInt)];
        let fiber = temp.split(':')[0];

        return {
            fiber: fiber,
            wls: uniqueChars,
            m: uniqueM
        };
    }
    state = {
        additionalSpecs: []
    };
    render() {
        return (
            <div>
                <div className="additional-specs-list section">
                    {this.state.additionalSpecs &&
                        this.state.additionalSpecs.map((value, index) => (
                            <AdditionalSpec
                                key={index + '-' + value.id}
                                criteria={value.criteria}
                                isCustom={value.isCustom}
                                customInput={value.customInput}
                                expressions={value.expressions}
                                operator={value.operator}
                                checkValidation={value.checkValidation}
                                created={value.created}
                                setExperssion={(newExperssions, operator) => {
                                    let additionalSpecs = [...this.state.additionalSpecs];

                                    if (operator == null) {
                                        additionalSpecs[index] = {
                                            ...this.state.additionalSpecs[index],
                                            expressions: newExperssions
                                        };
                                    } else {
                                        additionalSpecs[index] = {
                                            ...this.state.additionalSpecs[index],
                                            expressions: newExperssions,
                                            operator: operator
                                        };
                                    }
                                    this.setState({ additionalSpecs: additionalSpecs });
                                }}
                                setCriteriaWl={(newCriteria) => {
                                    let additionalSpecs = [...this.state.additionalSpecs];
                                    additionalSpecs[index] = {
                                        ...this.state.additionalSpecs[index],
                                        criteria: newCriteria
                                    };
                                    this.setState({ additionalSpecs: additionalSpecs });
                                }}
                                setCriteriaTest={(newCriteria) => {
                                    let additionalSpecs = [...this.state.additionalSpecs];
                                    additionalSpecs[index] = {
                                        ...this.state.additionalSpecs[index],
                                        criteria: newCriteria
                                    };
                                    this.setState({ additionalSpecs: additionalSpecs });
                                }}
                                setCheckValidation={(checkValidation) => {
                                    let additionalSpecs = [...this.state.additionalSpecs];
                                    additionalSpecs[index] = {
                                        ...this.state.additionalSpecs[index],
                                        checkValidation: checkValidation
                                    };
                                    this.setState({ additionalSpecs: additionalSpecs });
                                }}
                                setCreated={(value) => {
                                    if (this.state.additionalSpecs[index].isCustom) {
                                        let d = this.getData(this.state.additionalSpecs[index].customInput);

                                        let additionalSpecs = [...this.state.additionalSpecs];
                                        additionalSpecs[index] = {
                                            ...this.state.additionalSpecs[index],
                                            criteria: { ...this.state.additionalSpecs[index].criteria, wl: d.wls, test: d.m },
                                            selectedFiber: d.fiber,
                                            created: value
                                        };
                                        this.setState({ additionalSpecs: additionalSpecs });
                                        this.props.updateWizardData({ additionalSpecs: additionalSpecs });
                                    } else {
                                        let additionalSpecs = [...this.state.additionalSpecs];
                                        additionalSpecs[index] = {
                                            ...this.state.additionalSpecs[index],
                                            created: value
                                        };
                                        this.setState({ additionalSpecs: additionalSpecs });
                                        this.props.updateWizardData({ additionalSpecs: additionalSpecs });
                                    }
                                }}
                                setIsCustom={(value) => {
                                    let additionalSpecs = [...this.state.additionalSpecs];
                                    additionalSpecs[index] = {
                                        ...this.state.additionalSpecs[index],
                                        isCustom: value
                                    };
                                    this.setState({ additionalSpecs: additionalSpecs });
                                    this.props.updateWizardData({ additionalSpecs: additionalSpecs });
                                }}
                                setCustomInput={(value) => {
                                    let additionalSpecs = [...this.state.additionalSpecs];
                                    additionalSpecs[index] = {
                                        ...this.state.additionalSpecs[index],
                                        customInput: value
                                    };
                                    this.setState({ additionalSpecs: additionalSpecs });
                                    this.props.updateWizardData({ additionalSpecs: additionalSpecs });
                                }}
                                delete={() => {
                                    let additionalSpecs = [...this.state.additionalSpecs];

                                    additionalSpecs.splice(index, 1);

                                    this.setState({ additionalSpecs: additionalSpecs });
                                    this.props.updateWizardData({ additionalSpecs: additionalSpecs });
                                }}
                                assembly={this.props.assembly}
                                equipment={this.props.equipment}
                                wizard={this.props.wizard}
                            />
                        ))}
                    <div className="icon">
                        <Dropdown
                            overlay={
                                <Menu
                                    onClick={(e) => {
                                        this.setState({
                                            additionalSpecs: [
                                                ...this.state.additionalSpecs,
                                                {
                                                    criteria: { wl: null, test: null },
                                                    expressions: [
                                                        {
                                                            logic: null,
                                                            value: null,
                                                            type: null,
                                                            test: null,
                                                            wl: null
                                                        }
                                                    ],
                                                    operator: null,
                                                    checkValidation: false,
                                                    created: false,
                                                    isCustom: e.key === '1' ? false : true,
                                                    selectedFiber: '',
                                                    customInput: ''
                                                }
                                            ]
                                        });
                                    }}
                                >
                                    <Menu.Item key="1">Normal</Menu.Item>
                                    <Menu.Item key="2">Custom</Menu.Item>
                                </Menu>
                            }
                            trigger={['click']}
                        >
                            <Space>
                                <PlusCircleOutlined />
                            </Space>
                        </Dropdown>
                        {/* <PlusCircleOutlined /> */}
                    </div>
                </div>
            </div>
        );
    }
}
class AdditionalSpec extends Component {
    static propTypes = {
        setExperssion: PropTypes.func.isRequired,
        setCriteriaWl: PropTypes.func.isRequired,
        delete: PropTypes.func.isRequired,
        expressions: PropTypes.array.isRequired
    };
    state = {};

    render() {
        return (
            <React.Fragment>
                <div className="icon" onClick={() => this.props.delete()}>
                    <MinusCircleOutlined />
                </div>
                {this.props.created ? (
                    <div>
                        {this.props.isCustom ? (
                            <p className="experssion">{this.props.customInput}</p>
                        ) : (
                            <p className="experssion">
                                {this.props.criteria.test} @ {this.props.criteria.wl}{' '}
                                {this.props.expressions.map((exp, index) => (
                                    <React.Fragment>
                                        {exp.type === 'expr' ? (
                                            <React.Fragment>
                                                {exp.logic === '>=' && <>&ge;</>} {exp.logic === '<=' && <>&le;</>}{' '}
                                                {exp.logic === '>' && <>&gt;</>} {exp.logic === '<' && <>&lt;</>}
                                                {exp.logic !== '>' &&
                                                    exp.logic !== '>=' &&
                                                    exp.logic !== '<' &&
                                                    exp.logic !== '<=' && <>{exp.logic}</>}
                                                <>
                                                    {' '}
                                                    {exp.test}@{exp.wl}
                                                </>
                                            </React.Fragment>
                                        ) : (
                                            <React.Fragment>
                                                {exp.logic === '>=' && <>&ge;</>} {exp.logic === '<=' && <>&le;</>}{' '}
                                                {exp.logic === '>' && <>&gt;</>} {exp.logic === '<' && <>&lt;</>}{' '}
                                                {exp.logic !== '>' &&
                                                    exp.logic !== '>=' &&
                                                    exp.logic !== '<' &&
                                                    exp.logic !== '<=' && <>{exp.logic}</>}{' '}
                                                {exp.value}
                                            </React.Fragment>
                                        )}
                                    </React.Fragment>
                                ))}
                            </p>
                        )}
                    </div>
                ) : this.props.isCustom ? (
                    <div>
                        <Input
                            value={this.props.customInput}
                            onChange={(e) => {
                                this.props.setCustomInput(e.target.value);
                            }}
                        />
                    </div>
                ) : (
                    <div>
                        <React.Fragment>&nbsp;Select:&nbsp;</React.Fragment>

                        <Select
                            defaultValue={this.props.criteria.wl !== null ? this.props.criteria.wl : undefined}
                            placeholder="Wavelength"
                            style={{ width: 120 }}
                            onChange={(value) => {
                                let newCriteria = this.props.criteria;
                                newCriteria.wl = value;
                                this.props.setCriteriaWl(newCriteria);
                            }}
                        >
                            {this.props.wizard.wavelength_1310 && <Select.Option value={1310}>1310</Select.Option>}
                            {this.props.wizard.wavelength_1490 && <Select.Option value={1490}>1490</Select.Option>}
                            {this.props.wizard.wavelength_1550 && <Select.Option value={1550}>1550</Select.Option>}
                            {this.props.wizard.wavelength_1625 && <Select.Option value={1625}>1625</Select.Option>}
                            {this.props.wizard.wavelength_850 && <Select.Option value={850}>850</Select.Option>}
                            {this.props.wizard.wavelength_1300 && <Select.Option value={1300}>1300</Select.Option>}
                        </Select>
                        <React.Fragment>&nbsp; &amp; &nbsp;</React.Fragment>
                        <Select
                            defaultValue={this.props.criteria.test !== null ? this.props.criteria.test : undefined}
                            placeholder="Test"
                            onChange={(value) => {
                                let newCriteria = this.props.criteria;
                                newCriteria.test = value;
                                this.props.setCriteriaTest(newCriteria);
                            }}
                        >
                            {this.props.wizard.showDutLength && <Select.Option value="length">length</Select.Option>}
                            {this.props.assembly.returnLossSideA && <Select.Option value="rla">RLA</Select.Option>}
                            {this.props.assembly.returnLossSideB && <Select.Option value="rlb">RLB</Select.Option>}
                            {(this.props.assembly.insertionLossSideA || this.props.assembly.insertionLossSideB) &&
                                this.props.equipment.mtjConfiguration !== MTJ__DOUBLE && (
                                    <Select.Option value="il">IL</Select.Option>
                                )}

                            {this.props.assembly.insertionLossTotal &&
                                this.props.equipment.mtjConfiguration === MTJ__DOUBLE && (
                                    <Select.Option value="il">ILTotal</Select.Option>
                                )}
                            {this.props.assembly.returnLossTotal && <Select.Option value="rltotal">RLTotal</Select.Option>}
                        </Select>
                        <div>
                            {this.props.expressions.map((exp, index) => (
                                <div key={'ila-' + index}>
                                    <React.Fragment>&nbsp;Select:&nbsp;</React.Fragment>
                                    <Select
                                        defaultValue={
                                            this.props.expressions[index].type !== null
                                                ? this.props.expressions[index].type
                                                : undefined
                                        }
                                        style={{ width: 120 }}
                                        placeholder="Test/Value"
                                        onChange={(value) => {
                                            let newArray = [...this.props.expressions];
                                            newArray[index] = { ...newArray[index], type: value };
                                            this.props.setExperssion(newArray, null);
                                        }}
                                    >
                                        <Select.Option value="expr">test</Select.Option>
                                        <Select.Option value="value">value</Select.Option>
                                    </Select>
                                    <React.Fragment>&nbsp;&rArr;&nbsp;Select:&nbsp;</React.Fragment>
                                    {this.props.expressions[index].type === 'expr' ? (
                                        <React.Fragment>
                                            <Select
                                                defaultValue={
                                                    this.props.expressions[index].logic !== null
                                                        ? this.props.expressions[index].logic
                                                        : undefined
                                                }
                                                style={{ width: 120 }}
                                                placeholder="Operator"
                                                onChange={(value) => {
                                                    let newArray = [...this.props.expressions];
                                                    newArray[index] = { ...newArray[index], logic: value };
                                                    if (value === '>' || value === '<' || value === '>=' || value === '<=') {
                                                        this.props.setExperssion(newArray, true);
                                                    } else if (
                                                        (value === '*' || value === '/' || value === '-' || value === '+') &&
                                                        (this.props.expressions[index].logic === '<=' ||
                                                            this.props.expressions[index].logic === '>=' ||
                                                            this.props.expressions[index].logic === '>' ||
                                                            this.props.expressions[index].logic === '<')
                                                    ) {
                                                        this.props.setExperssion(newArray, false);
                                                    } else {
                                                        this.props.setExperssion(newArray, null);
                                                    }
                                                }}
                                            >
                                                {(!this.props.operator ||
                                                    this.props.expressions[index].logic === '>' ||
                                                    this.props.expressions[index].logic === '<' ||
                                                    this.props.expressions[index].logic === '>=' ||
                                                    this.props.expressions[index].logic === '<=') && (
                                                    <Select.OptGroup>
                                                        <Select.Option value="<=">&le;</Select.Option>
                                                        <Select.Option value=">=">&ge;</Select.Option>
                                                        <Select.Option value=">">&gt;</Select.Option>
                                                        <Select.Option value="<">&lt;</Select.Option>
                                                    </Select.OptGroup>
                                                )}
                                                <Select.Option value="+">+</Select.Option>
                                                <Select.Option value="-">-</Select.Option>
                                                <Select.Option value="*">*</Select.Option>
                                                <Select.Option value="/">/</Select.Option>
                                            </Select>

                                            <React.Fragment>&nbsp; &amp; &nbsp;</React.Fragment>
                                            <Select
                                                defaultValue={
                                                    this.props.expressions[index].wl !== null
                                                        ? this.props.expressions[index].wl
                                                        : undefined
                                                }
                                                placeholder="Wavelength"
                                                style={{ width: 120 }}
                                                onChange={(value) => {
                                                    let newArray = [...this.props.expressions];
                                                    newArray[index] = { ...newArray[index], wl: value };
                                                    this.props.setExperssion(newArray, null);
                                                }}
                                            >
                                                {this.props.wizard.wavelength_1310 && (
                                                    <Select.Option value={1310}>1310</Select.Option>
                                                )}
                                                {this.props.wizard.wavelength_1490 && (
                                                    <Select.Option value={1490}>1490</Select.Option>
                                                )}
                                                {this.props.wizard.wavelength_1550 && (
                                                    <Select.Option value={1550}>1550</Select.Option>
                                                )}
                                                {this.props.wizard.wavelength_1625 && (
                                                    <Select.Option value={1625}>1625</Select.Option>
                                                )}

                                                {this.props.wizard.wavelength_850 && (
                                                    <Select.Option value={850}>850</Select.Option>
                                                )}
                                                {this.props.wizard.wavelength_1300 && (
                                                    <Select.Option value={1300}>1300</Select.Option>
                                                )}
                                            </Select>
                                            <React.Fragment>&nbsp; &amp; &nbsp;</React.Fragment>
                                            <Select
                                                defaultValue={
                                                    this.props.expressions[index].test !== null
                                                        ? this.props.expressions[index].test
                                                        : undefined
                                                }
                                                style={{ width: 120 }}
                                                placeholder="Test"
                                                onChange={(value) => {
                                                    let newArray = [...this.props.expressions];
                                                    newArray[index] = { ...newArray[index], test: value };
                                                    this.props.setExperssion(newArray, null);
                                                }}
                                            >
                                                {this.props.assembly.returnLossSideA && (
                                                    <Select.Option value="rla">RLA</Select.Option>
                                                )}
                                                {this.props.assembly.returnLossSideB && (
                                                    <Select.Option value="rlb">RLB</Select.Option>
                                                )}
                                                {(this.props.assembly.insertionLossSideA ||
                                                    this.props.equipment.mtjConfiguration !== MTJ__DOUBLE) && (
                                                    <Select.Option value="il">IL</Select.Option>
                                                )}

                                                {(this.props.assembly.insertionLossTotal ||
                                                    this.props.equipment.mtjConfiguration === MTJ__DOUBLE) && (
                                                    <Select.Option value="il">ILTotal</Select.Option>
                                                )}
                                                {this.props.assembly.returnLossTotal && (
                                                    <Select.Option value="rlt">RLTotal</Select.Option>
                                                )}
                                                {this.props.wizard.showDutLength && (
                                                    <Select.Option value="length">length</Select.Option>
                                                )}
                                            </Select>
                                            <React.Fragment>&nbsp;&nbsp;</React.Fragment>

                                            <React.Fragment>&nbsp;&nbsp;</React.Fragment>
                                        </React.Fragment>
                                    ) : (
                                        this.props.expressions[index].type === 'value' && (
                                            <React.Fragment>
                                                <Select
                                                    defaultValue={
                                                        this.props.expressions[index].logic !== null
                                                            ? this.props.expressions[index].logic
                                                            : undefined
                                                    }
                                                    style={{ width: 120 }}
                                                    placeholder="Operator"
                                                    onChange={(value) => {
                                                        let newArray = [...this.props.expressions];
                                                        newArray[index] = { ...newArray[index], logic: value };
                                                        if (
                                                            value === '>' ||
                                                            value === '<' ||
                                                            value === '>=' ||
                                                            value === '<='
                                                        ) {
                                                            this.props.setExperssion(newArray, true);
                                                        } else if (
                                                            (value === '*' ||
                                                                value === '/' ||
                                                                value === '-' ||
                                                                value === '+') &&
                                                            (this.props.expressions[index].logic === '<=' ||
                                                                this.props.expressions[index].logic === '>=' ||
                                                                this.props.expressions[index].logic === '>' ||
                                                                this.props.expressions[index].logic === '<')
                                                        ) {
                                                            this.props.setExperssion(newArray, false);
                                                        } else {
                                                            this.props.setExperssion(newArray, null);
                                                        }
                                                    }}
                                                >
                                                    {(!this.props.operator ||
                                                        this.props.expressions[index].logic === '>' ||
                                                        this.props.expressions[index].logic === '<' ||
                                                        this.props.expressions[index].logic === '>=' ||
                                                        this.props.expressions[index].logic === '<=') && (
                                                        <Select.OptGroup>
                                                            <Select.Option value="<=">&le;</Select.Option>
                                                            <Select.Option value=">=">&ge;</Select.Option>
                                                            <Select.Option value=">">&gt;</Select.Option>
                                                            <Select.Option value="<">&lt;</Select.Option>
                                                        </Select.OptGroup>
                                                    )}
                                                    <Select.Option value="+">+</Select.Option>
                                                    <Select.Option value="-">-</Select.Option>
                                                    <Select.Option value="*">*</Select.Option>
                                                    <Select.Option value="/">/</Select.Option>
                                                </Select>
                                                <React.Fragment>&nbsp; &amp; &nbsp;</React.Fragment>
                                                <InputNumber
                                                    defaultValue={
                                                        this.props.expressions[index].value !== null
                                                            ? this.props.expressions[index].value
                                                            : undefined
                                                    }
                                                    //min={0}
                                                    onChange={(value) => {
                                                        //if (value > 0 && value < 10000) {
                                                        let newArray = [...this.props.expressions];
                                                        newArray[index] = { ...newArray[index], value: value };
                                                        this.props.setExperssion(newArray, null);
                                                        // }
                                                    }}
                                                    formatter={(value) => `${value.toString().replace(/^[A-Za-z--]+$/, '')}`}
                                                />
                                                <React.Fragment>&nbsp;&nbsp;</React.Fragment>
                                                <CloseCircleOutlined
                                                    onClick={() => {
                                                        if (
                                                            this.props.expressions[index].logic === '>=' ||
                                                            this.props.expressions[index].logic === '<=' ||
                                                            this.props.expressions[index].logic === '<' ||
                                                            this.props.expressions[index].logic === '>'
                                                        ) {
                                                            let newArray = this.props.expressions;
                                                            newArray = newArray.splice(index, 1);
                                                            this.props.setExperssion(newArray, false);
                                                        } else {
                                                            let newArray = this.props.expressions;
                                                            newArray = newArray.splice(index, 1);
                                                            this.props.setExperssion(newArray, null);
                                                        }
                                                    }}
                                                />
                                                <React.Fragment>&nbsp;&nbsp;</React.Fragment>
                                            </React.Fragment>
                                        )
                                    )}
                                </div>
                            ))}
                        </div>
                        <Button
                            type="Dashed"
                            shape="round"
                            icon={<PlusCircleOutlined />}
                            onClick={() => {
                                let newArray = this.props.expressions;
                                newArray = newArray.concat({
                                    logic: null,
                                    value: null,
                                    type: null,
                                    test: null,
                                    wl: null
                                });
                                this.props.setExperssion(newArray, null);
                            }}
                        >
                            Add Expression
                        </Button>
                    </div>
                )}
                <div className="create-div">
                    {this.props.created ? (
                        <Button
                            type="normal"
                            onClick={() => {
                                this.props.setCreated(false);
                            }}
                        >
                            Edit
                        </Button>
                    ) : (
                        <Button
                            type="primary"
                            onClick={() => {
                                if (this.props.isCustom) {
                                    if (this.props.customInput !== '') {
                                        this.props.setCreated(true);
                                    }
                                } else {
                                    let check = false;
                                    if (this.props.criteria.wl === null) {
                                        check = true;
                                    } else if (this.props.criteria.test === null) {
                                        check = true;
                                    } else if (!this.props.operator) {
                                        check = true;
                                    } else {
                                        for (let expr of this.props.expressions) {
                                            if (expr.logic === null) {
                                                check = true;
                                                break;
                                            }
                                            if (expr.type === 'expr') {
                                                if (expr.wl === null) {
                                                    check = true;
                                                    break;
                                                }
                                                if (expr.test === null) {
                                                    check = true;
                                                    break;
                                                }
                                            } else if (expr.type === 'value') {
                                                if (expr.value === null) {
                                                    check = true;
                                                    break;
                                                }
                                            }
                                        }
                                    }

                                    if (!check) {
                                        this.props.setCreated(true);
                                    }
                                }
                            }}
                        >
                            Create
                        </Button>
                    )}
                </div>
            </React.Fragment>
        );
    }
}
